import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Hidden,
  withStyles,
  Grid,
  Divider,
  Box,
  Typography,
  Button,
  Card,
  CardMedia,
  CardContent,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Avatar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Fab,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import HomeImg from "../assets/img/org/webQuotationHome.png";
import {
  border,
  borderRadius,
  color,
  fontSize,
  fontWeight,
  padding,
} from "@mui/system";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import SavingMeterImg from "../assets/img/org/savingMeter.png";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import CropFreeIcon from "@material-ui/icons/CropFree";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import Logo from "../assets/img/org/deco_white_logo.png";
import BlueLogo from "../assets/img/org/deco_new_logo.png";
import PaymentBanner from "../assets/img/org/paymentBanner.png";
import HttpService from "../services/httpService";
import { setLoading, setSnackInfo } from "../redux/actions/appAction";
import { ArrowBackIos, ArrowForwardIos, Details } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import NavigationIcon from "@material-ui/icons/Navigation";
import { useDispatch, useSelector } from "react-redux";
import { Carousel } from "antd";
import HomeMobile from "../assets/img/org/HomeMobile.png"
import ExitToApp from '@material-ui/icons/ExitToApp';
import Dashboard from '@material-ui/icons/Dashboard';
import Tooltip from '@material-ui/core/Tooltip';
import DescriptionIcon from "@material-ui/icons/Description";


const styles = makeStyles((theme) => ({
  logo: {
    height: 50,
    marginRight: theme.spacing(1),
    width: "180px",
  },
  navItems: {
    display: "flex",
    gap: theme.spacing(3),
  },
  heroContent: {
    padding: theme.spacing(10, 3),
    maxWidth: 800,
    marginLeft: theme.spacing(8),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(8, 2),
      marginLeft: 0,
    },
  },
  buttonWhite: {
    color: "white",
    borderColor: "white",
    "&:hover": {
      borderColor: "white",
      backgroundColor: "rgba(255,255,255,0.1)",
    },
    borderRadius: "20px",
    padding: "10px",
  },
  buttonPrimary: {
    backgroundColor: "white",
    color: "#ff5a3c",
    "&:hover": {
      backgroundColor: "#f0f0f0",
    },
    borderRadius: "20px",
    padding: "10px",
  },
  heading: {
    fontWeight: "bold",
    marginBottom: theme.spacing(1),
  },
  subHeading: {
    color: "gray",
    marginBottom: theme.spacing(4),
  },
  card: {
    maxWidth: 380,
    margin: "auto",
    border: "1px dashed #ccc",
    borderRadius: 12,
    boxShadow: theme.shadows[2],
  },
  cardMedia: {
    height: 240,
    borderRadius: "12px 12px 0 0",
  },
  button: {
    background: "#F47E46",
    marginTop: theme.spacing(1),
    borderRadius: 30,
    padding: theme.spacing(1, 3),
    fontWeight: "bold",
    color: "white",
  },
  arrows: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    background: "white",
    border: "1px solid #ccc",
    borderRadius: "50%",
    width: 40,
    height: 40,
    zIndex: 2,
  },
  dots: {
    marginTop: theme.spacing(2),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  dot: {
    height: 10,
    width: 10,
    margin: "0 5px",
    display: "inline-block",
    borderRadius: "50%",
    background: "#ccc",
    cursor: "pointer",
  },
  dotActive: {
    background: "#F47E46",
  },
  bottomSection: {
    display: "flex",
    flexDirection: "row",
  },
  quoteBox: {
    flex: 1,
    background: "white",
    textAlign: "left",
    padding: theme.spacing(3),
    boxShadow: theme.shadows[2],
    borderLeft: "8px solid #F47E46",
  },
  saveBox: {
    background: "#F47E46",
    color: "white",
    textAlign: "center",
    padding: theme.spacing(3),
    fontWeight: "bold",
    border: "2px solid green",
  },
}));

const navItems = [
  // { id: "overview", name: "Overview" },
  { id: "cost-summary", name: "Summary" },
  { id: "why-decorpot", name: "Why Us" },
  { id: "cost-breakdown", name: "Breakup" },
  { id: "gallery", name: "Gallery" },
  { id: "testimonial", name: "Testimonial" },
  { id: "payment-terms", name: "Payment Terms" },
  // { id: "contact-us", name: "Contact Us" },
];

const ORANGE = "#F47E46";
const BLUE = "#1C375D";

const dataPaymentSchedule = [
  {
    id: 1,
    title: "10%",
    desc: "of the quotation for design meetings and booking confirmation.",
  },
  {
    id: 2,
    title: "50%",
    desc: "upon signing of the contract.",
  },
  {
    id: 3,
    title: "40%",
    desc: "before delivery of the modular furnitures at the site.",
  },
  {
    id: 4,
    desc: "Amount once paid is non refundable.",
  },
  {
    id: 5,
    desc: "Projects start at a minimum value of ₹4 lakhs+GST",
  },
  // {
  //   id: 6,
  //   highlight: true,
  //   title: "0 Cost EMI",
  //   desc: "for 24 months only if there is no discount on the quotation. Discounts and Zero Cost EMI, both are mutually exclusive and cannot be combined",
  // },
  {
    id: 7,
    highlight: true,
    title: "Decorpot 10-Year's Warranty",
    desc: "All your woodwork is covered under the Decorpot 10-year warranty. This safeguards you against any defect in manufacturing or in installation workmanship. Please refer to Decorpot standard terms and conditions document for further details.",
  },
];

const dataTable = [
  { particular: "Plywood (Dry Areas)", brand: "303 (MR Grade)" },
  // { particular: "Plywood (Wet Areas)", brand: "Green-Ply Absolute (BWP Ply)" },
  { particular: "Plywood (Wet Areas) (Kitchen, Vanity, Washroom and Utility)", brand: "Green Ply/Century Ply BWP" },
  { particular: "Outer Laminate (1 MM)", brand: "Stylam/Airolam/IndiaLAM" },
  { particular: "Hinges and Channels", brand: "Hettich" },
  { particular: "Glass", brand: "Modiguard / AIS / Saint Gobain" },
];

const bankDetails = [
  { label: "Name", value: "DECORPOT PRIVATE LIMITED" },
  { label: "Virtual A/C Number", value: "DECR23NT0924036" },
  { label: "Bank", value: "HDFC Bank" },
  { label: "IFSC Code", value: "HDFC0001993" },
  { label: "Branch", value: "HSR Main Branch" },
  { label: "A/c Type", value: "Current Account" },
];

// The QR, framed, with the UPI ID it encodes on a bar underneath.
//
// The QR is only a shortcut to  DECR23<lead number>@hdfcbank  (see
// services/qr_code.service.js). Printing it under the code lets the customer
// confirm where their money is going before sending it, and gives them a way to
// pay when scanning isn't an option - reading the quotation on the same phone
// they would otherwise scan with, or off a printed copy.
const QrCard = ({ src, size, virtualAccount, onCopy, onError }) => {
  const upiId = virtualAccount ? `${virtualAccount}@hdfcbank` : "";
  return (
    <div
      style={{
        // `size` is the QR itself, so the frame is added ON TOP of it - the
        // white box is width:auto, so it eats its own border and padding out of
        // the card's content box and the code would otherwise come out 18px
        // smaller than asked for. 2x12 card padding + 2x6 inner + 2x3 border.
        width: size + 42,
        maxWidth: "100%",
        margin: "10px auto 0",
        background: "#f5f6f8",
        borderRadius: 14,
        padding: 12,
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          background: "#fff",
          border: "3px solid #1C375D",
          borderRadius: 12,
          padding: 6,
        }}
      >
        <img
          src={src}
          alt="UPI QR"
          onError={onError}
          style={{ display: "block", width: "100%", height: "auto" }}
        />
      </div>

      {upiId ? (
        <div
          style={{
            background: "#1C375D",
            borderRadius: 9,
            marginTop: 8,
            padding: "5px 6px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 2,
          }}
        >
          <span
            style={{
              color: "#fff",
              fontSize: 11.5,
              fontWeight: 700,
              letterSpacing: 0.2,
              wordBreak: "break-all",
            }}
          >
            {upiId}
          </span>
          {onCopy ? (
            <IconButton
              size="small"
              aria-label="Copy UPI ID"
              onClick={() => onCopy(upiId)}
              style={{ color: "rgba(255,255,255,0.9)", padding: 2 }}
            >
              <FileCopyIcon style={{ fontSize: 13 }} />
            </IconButton>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};

// Shown in place of the QR card when there isn't one to show - either the lead
// has no payment_qr_code stored, or the stored image fails to load.
const PaymentQrUnavailable = ({ size, virtualAccount, onCopy }) => {
  // virtualAccount is already "DECR23<lead number>"; the VPA is that plus the
  // bank handle. Blank if the lead number hasn't loaded, in which case the
  // bank-transfer line below still stands on its own.
  const upiId = virtualAccount ? `${virtualAccount}@hdfcbank` : "";

  return (
    <div
      style={{
        width: size,
        // minHeight, not height: the UPI ID wraps on narrow screens and the box
        // has to be allowed to grow rather than clip the instructions.
        minHeight: size,
        maxWidth: "100%",
        margin: "10px auto",
        border: "1px dashed #c8b7a6",
        borderRadius: 8,
        background: "#fff8f2",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: 14,
        boxSizing: "border-box",
        textAlign: "center",
      }}
    >
      {/* MUI v4 has no QR glyph; CropFree is the four-corner scan frame. */}
      <CropFreeIcon style={{ fontSize: 28, color: "#F18A52", marginBottom: 6 }} />
      <div style={{ fontSize: 14, fontWeight: 700, color: "#26263F", lineHeight: 1.3 }}>
        UPI QR not available
      </div>

      {upiId ? (
        <>
          <div style={{ fontSize: 12.5, color: "#5c5c6e", marginTop: 8, lineHeight: 1.4 }}>
            You can still pay by UPI — enter this UPI ID in any UPI app:
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 2,
              marginTop: 5,
              maxWidth: "100%",
            }}
          >
            <span
              style={{
                fontSize: 12.5,
                fontWeight: 700,
                color: "#26263F",
                wordBreak: "break-all",
              }}
            >
              {upiId}
            </span>
            {onCopy ? (
              <IconButton
                size="small"
                aria-label="Copy UPI ID"
                onClick={() => onCopy(upiId)}
                style={{ color: "#f47e46", padding: 3 }}
              >
                <FileCopyIcon style={{ fontSize: 14 }} />
              </IconButton>
            ) : null}
          </div>
        </>
      ) : null}

      <div style={{ fontSize: 11.5, color: "#7a7a8a", marginTop: 8, lineHeight: 1.4 }}>
        Or transfer to the <b style={{ color: "#5c5c6e" }}>Virtual A/C Number</b>{" "}
        listed here — it is the same account.
      </div>
    </div>
  );
};

function CxWebQuotation(props) {
  const classes = styles();
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const themes = useTheme();
  const isSmall = useMediaQuery(themes.breakpoints.down("sm"));
  const isTablet = useMediaQuery(themes.breakpoints.between("sm", "md")); // tablets (600px–900px)
  const isNestHub = useMediaQuery(themes.breakpoints.between("md", "lg"));
  const isMobile = isSmall || isTablet || isNestHub
  const [currentIndex, setCurrentIndex] = useState(0);
  const isHighlighted = (i) => (isMobile ? i === currentIndex : i === 0);
  const [visibleCount, setVisibleCount] = useState(2);
  const [quotationInfo, setQuotationInfo] = useState([]);
  const [leadId, setLeadId] = useState("");
  const [versionNo, setVersionNo] = useState("");
  const [costSummaryImages, setAllCostSummaryImages] = useState([]);
  const [costBreakDownImages, setAllCostBreakDownImages] = useState([]);
  const [whyChooseUsContent, setWhyChooseUsContent] = useState([]);
  const [accordionData, setAccordionData] = useState([]);
  const [partners, setPartners] = useState([]);
  const [customerTestimonials, setCustomerTestimonials] = useState([]);
  const [galleryImages, setGalleryImages] = useState([]);
  const { customerDetails } = useSelector((state) => state.customer);
  const [socialMediaLinks, setSocialMediaLink] = useState([]);
  const [colouredLeadNumber, setColouredLeadNumber] = useState("");
  // A stored payment_qr_code can still 404 (the upload failed, or the file was
  // removed), which renders as a broken image under a "Scan the QR code"
  // heading. onError flips this so the same fallback covers both cases.
  const [qrLoadFailed, setQrLoadFailed] = useState(false);
  const history = useHistory();
  const { user, encodedParams } = useParams();
  const stats = [
    { value: "10,000+", label: "Homes Delivered" },
    { value: "400+", label: "In-house Designers" },
    { value: "37+", label: "Experience Centers" },
  ];
  const headerStyle = {
    padding: "12px",
    fontSize: "15px",
    fontWeight: "600",
    borderBottom: "1px solid #eee",
    textAlign: "center",
  };

  const cellStyle = {
    padding: "12px",
    fontSize: "14px",
    color: "#333",
    borderBottom: "1px solid #eee",
    fontWeight: "600",
  };

  const iconStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "40px",
    height: "40px",
    border: "1px solid #222",
    borderRadius: "50%",
    fontSize: "14px",
    textDecoration: "none",
    color: "#222",
  };

  // visibleCards should be before handlers
  const visibleCards = isMobile ? 1 : 3;
  const totalPages = Math.ceil(
    quotationInfo?.components?.length / visibleCards
  );

  const handleNext = () => {
    setCurrentIndex((prev) =>
      prev + visibleCards >= quotationInfo?.components?.length
        ? 0 // go back to start
        : prev + visibleCards
    );
  };

  const handlePrev = () => {
    setCurrentIndex((prev) =>
      prev - visibleCards < 0
        ? (totalPages - 1) * visibleCards // go to last page
        : prev - visibleCards
    );
  };

  // default expanded is the last accordion
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  // for partners images
  const [pagePartners, setPagePartners] = useState(0);
  const totalPagesPartners = partners.length;
  const goPrevPartners = () => setPagePartners((p) => Math.max(0, p - 1));
  const goNextPartners = () =>
    setPagePartners((p) => Math.min(totalPagesPartners - 1, p + 1));

  // for partners images

  const [pageGallery, setPageGallery] = useState(0);
  const totalPagesGallery = galleryImages.length;

  // for Testimonials
  const [pageTestimonial, setPageTestimonial] = useState(0);
  const totalPagesTestimonial = customerTestimonials.length;

  const goPrevTestimonial = () => setPageTestimonial((p) => Math.max(0, p - 1));
  const goNextTestimonial = () =>
    setPageTestimonial((p) => Math.min(totalPagesTestimonial - 1, p + 1));

  // for cost Summary
  const [pageCostSummary, setPageCostSummary] = useState(0);
  const totalPagesCostSummary = quotationInfo?.components?.length;

  const goPrevCostSummary = () => setPageCostSummary((p) => Math.max(0, p - 1));
  const goNextCostSummary = () =>
    setPageCostSummary((p) => Math.min(totalPagesCostSummary - 1, p + 1));

  // for cost Summary
  const [pageWhyChooseUs, setPageWhyChooseUs] = useState(0);
  const totalPagesWhyChooseUs = whyChooseUsContent?.length;

  const goPrevWhyChooseUs = () => setPageWhyChooseUs((p) => Math.max(0, p - 1));
  const goNextWhyChooseUs = () =>
    setPageWhyChooseUs((p) => Math.min(totalPagesWhyChooseUs - 1, p + 1));

  // for annexure
  const [pageAnnexure, setPageAnnexure] = useState(0);
  const totalPagesAnnexure = 2;

  const goPrevAnnexure = () => setPageAnnexure((p) => Math.max(0, p - 1));
  const goNextAnnexure = () =>
    setPageAnnexure((p) => Math.min(totalPagesAnnexure - 1, p + 1));

  // Show more for gallery

  const handleShowMore = () => {
    setVisibleCount(galleryImages.length); // show all items
  };

  // Legends for alpabets and numbers

  const Legend = () => (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "13px",
        color: "#626277",
        fontWeight: 600,
      }}
    >
      <span style={{ display: "inline-flex", alignItems: "center", gap: "8px" }}>
        <i
          style={{
            width: 14,
            height: 14,
            borderRadius: 3,
            background: "#5A5A7C",
          }}
        />
        Alphabets
      </span>
      <span style={{ display: "inline-flex", alignItems: "center", gap: "8px" }}>
        <i
          style={{
            width: 14,
            height: 14,
            borderRadius: 3,
            background: "#E57C4E",
          }}
        />
        Numbers
      </span>
    </div>
  );

  // Bank Details Copy
  const handleCopy = async (text) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      try {
        await navigator.clipboard.writeText(text);
        alert(`Copied: ${text}`);
      } catch (err) {
        console.error("Failed to copy: ", err);
        alert("Failed to copy text. Please try again.");
      }
    } else {
      // fallback method (older browsers)
      const textarea = document.createElement("textarea");
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      alert(`Copied (fallback): ${text}`);
    }
  };
  

  // Get all choose us content

  const whyhooseUsFunApi = async () => {
    try {
      props.setLoading(true);
      const fetchData = await HttpService?.whyChooseUsNewGet();
      setWhyChooseUsContent(fetchData?.data || []);
    } catch (error) {
      props.setLoading(false);
    }
  };

  // Combine and encod
  useEffect(() => {
    if (encodedParams) {
      try {
        // Decode the Base64 string
        const decodedString = atob(encodedParams);
        const [decodedLeadId, decodedVersionNo] = decodedString.split("/");

        if (decodedLeadId && decodedVersionNo) {
          setLeadId(decodedLeadId);
          setVersionNo(decodedVersionNo);
        } else {
          console.error("Invalid encoded parameters.");
        }
      } catch (err) {
        console.error("Error decoding parameters:", err);
      }
    }
  }, [encodedParams]);

  // calling Quotation info api

  async function webQuotationCustomerInfoFun(versionNo, leadId) {

    if (!versionNo || !leadId) return; // Defensive: don't run if values are missing

    try {
      props.setLoading(true);

      const fetchData = await HttpService.webQuotationCustomerInfo(
        versionNo,
        leadId
      );
      setQuotationInfo(fetchData.data);
      setAccordionData(fetchData.data.components);
      // set default expanded as last accordion after data loads
      if (fetchData.data.components.length > 0) {
        setExpanded(
          String(
            fetchData.data.components[fetchData.data.components.length - 1]._id
          )
        );
      }
      setColouredLeadNumber(`DECR23${fetchData?.data?.uniqueLeadNumber}`);
      // Fresh quotation, fresh chance for the image to load.
      setQrLoadFailed(false);
    } catch (error) {
      console.error("API error:", error);
      if (error.response && error.response.status === 404) {
        const errorMsg = error.response.data?.error || "Quotation not found";
        history.push("/webQuotation/access-denied");
      }
    } finally {
      props.setLoading(false);
    }
  }

  // cost Summary image api

  const costSummaryItemGet = async () => {
    try {
      props.setLoading(true);
      const fetchData = await HttpService?.costSummaryItemGet();
      setAllCostSummaryImages(fetchData?.data || []);
    } catch (error) {
      props.setLoading(false);
    }
  };

  // cost Break Down image api

  const costBreakDownItemGet = async () => {
    try {
      props.setLoading(true);
      const fetchData = await HttpService?.costBreakDownItemGet();
      setAllCostBreakDownImages(fetchData?.data || []);
    } catch (error) {
      props.setLoading(false);
    }
  };

  // discount Calculation Function

  function discountCalculationFun(amount, discountRate) {
    const discountAmount = (amount * discountRate) / 100;
    const amountAfterDiscount = amount - discountAmount;
    return amountAfterDiscount;
  }

  // Gallery Carousel controls
  const goPrevGallery = (categoryName) => {
    setPageGallery((prev) => ({
      ...prev,
      [categoryName]: Math.max((prev[categoryName] || 0) - 1, 0),
    }));
  };

  const goNextGallery = (categoryName, imagesLength) => {
    setPageGallery((prev) => ({
      ...prev,
      [categoryName]: Math.min((prev[categoryName] || 0) + 1, imagesLength - 1),
    }));
  };

  const handleDotClick = (categoryName, index) => {
    setPageGallery((prev) => ({
      ...prev,
      [categoryName]: index,
    }));
  };

  // Customer testimonials

  const customerTestimonialsGetFun = async () => {
    try {
      props.setLoading(true);
      const fetchData = await HttpService?.customerTestimonialsGet();
      setCustomerTestimonials(fetchData?.data || []);
    } catch (error) {
      console.error("Error fetching testimonials:", error);
    } finally {
      props.setLoading(false);
    }
  };

  const webQuotationOpenActivityFun = async (leadId, versionNo) => {
    try {
      props.setLoading(true);
      const fetchData = await HttpService.webQuotationOpenActivity(
        leadId,
        versionNo
      );
      props.setLoading(false);
    } catch (error) {
      props.setLoading(false);
    }
  };

  const webQuotationCloseActivityFun = async (leadId, versionNo) => {
    try {
      props.setLoading(true);
      const fetchData = await HttpService.webQuotationCloseActivity(
        leadId,
        versionNo
      );
      props.setLoading(false);
    } catch (error) {
      props.setLoading(false);
    }
  };

  const linkProtectedFun = async (versionNo, leadId) => {
    try {
      props.setLoading(true);
      const fetchData = await HttpService.protectWebQuotationLink();
      if (versionNo && leadId) {
        webQuotationCustomerInfoFun(versionNo, leadId);
        costSummaryItemGet();
        whyhooseUsFunApi();
        customerTestimonialsGetFun();
        handlePartnersLogo();
        galleryCategoryWebQuotationGetHandle();
        setSocialMediaLinkHandle();
        costBreakDownItemGet();
      }
      props.setLoading(false);
    } catch (error) {
      props.setLoading(false);

      if (user === "cx") {
        const encoded = btoa(`${leadId}/${versionNo}`);
        localStorage.setItem("redirectTo", `/webQuotation/cx/${encoded}`);
        history.push("/user-login");
      } else if (user === "erpUser") {
        const encoded = btoa(`${leadId}/${versionNo}`);
        localStorage.setItem("redirectTo", `/webQuotation/erpUser/${encoded}`);
        history.push("/");
      }
    }
  };

  function wasOpenedByScript() {
    const flag = sessionStorage.getItem("wasOpenedByScript");
    sessionStorage.removeItem("wasOpenedByScript");
    return flag !== null && flag === "true";
  }

  // logout

  // const handleLogOut = async () => {
  //   try {
  //     let handleCustomerLogout = await HttpService.handleCustomerLogout(
  //       customerDetails._id
  //     );
  //   } catch (error) {
  //     console.error("Token not available.");
  //   }
  //   localStorage.clear();
  //   history.push("/user-login");
  //   window.location.reload();
  // };

    // convert rs in comma saprator
    function formatToINR(amount) {
      return Number(amount).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }
    

  const handlePartnersLogo = async () => {
    try {
      props.setLoading(true);
      const fetchData = await HttpService.getPartnersImg();
      setPartners(fetchData?.data);
    } catch (error) {
      console.error("Error fetching data:", error);
      props.setSnackInfo({ message: "Error fetching data", severity: "error" });
    } finally {
      props.setLoading(false);
    }
  };

  const galleryCategoryWebQuotationGetHandle = async () => {
    try {
      props.setLoading(true);
      const fetchData = await HttpService?.galleryCategoryWebQuotationGet();
      setGalleryImages(fetchData?.data || []);
    } catch (error) {
      props.setLoading(false);
    }
  };

  // Gst Calculation Function

  function gstCalculationFun(amount, discountRate) {
    const gstAmount = (amount * discountRate) / 100;
    // const totalAmount = amountAfterDiscount + gstAmount;
    return gstAmount;
  }

  const setSocialMediaLinkHandle = async () => {
    const res = await HttpService.socialMediaWebQuotationGet();
    setSocialMediaLink(res.data);
  };

  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      // Display a confirmation message to the user (optional)
      const token = localStorage.getItem("token");
      if (user === "cx" && token && versionNo !== "" && leadId !== "") {
        webQuotationCloseActivityFun(leadId, versionNo);
      }
      event.preventDefault();
      event.returnValue = ""; // Required for some browsers
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [leadId, versionNo]);

  useEffect(() => {
    if (versionNo !== "" && leadId !== "") {
      linkProtectedFun(versionNo, leadId);
    }
  }, [versionNo, leadId]);

  useEffect(() => {
    const navEntries = performance.getEntriesByType("navigation");
    const navType = navEntries.length > 0 ? navEntries[0].type : null;
    const redirectTo = localStorage.getItem("redirectTo");
    const token = localStorage.getItem("token");

    if (navType === "reload") {
      if (redirectTo !== "" && token && versionNo !== "" && leadId !== "") {
        webQuotationOpenActivityFun(leadId, versionNo);
      }
    } else {
      // If redirected and value exists in localStorage
      if (user === "cx" && token && versionNo !== "" && leadId !== "") {
        webQuotationOpenActivityFun(leadId, versionNo);
        // Clean up localStorage so it doesn't trigger again
        localStorage.removeItem("redirectTo");
      }
    }
  }, [leadId, versionNo]);

    // discount Calculation Function

  function discountCalculationFun(amount, discountRate) {
    const discountAmount = (amount * discountRate) / 100;
    const amountAfterDiscount = amount - discountAmount;
    return amountAfterDiscount;
  }

  // Gst Calculation Function

  function gstCalculationFun(amount, discountRate) {
    const gstAmount = (amount * discountRate) / 100;
    // const totalAmount = amountAfterDiscount + gstAmount;
    return gstAmount;
  }

  const capitalizeFirstWord = (name = "") => {
    const words = name.trim().split(" ");
    if (!words.length) return "";
    words[0] = words[0].charAt(0).toUpperCase() + words[0].slice(1);
    return words.join(" ");
  };
  

  return (
    <Box>
      {JSON.stringify(quotationInfo) !== "{}" && (
        <Box style={{ backgroundColor: "#FAFAFA" }}>
          <Box
            sx={{
              position: "fixed",
              bottom: 16,
              right: 16,
              boxShadow: 3,
              borderRadius: "50%",
              zIndex: "1111",
            }}
          >
            <Fab
              color="primary"
              style={{
                backgroundColor: "#F47E46", // Decorpot Orange
                "&:hover": { backgroundColor: "#E76A38" }, // Slightly darker for hover effect
              }}
              onClick={() => [handleScrollToTop()]}
            >
              <NavigationIcon fontSize="large" sx={{ color: "white" }} />
            </Fab>
          </Box>
          <Box
            style={{
              height: "100vh",
              backgroundImage: isMobile ? `url(${HomeMobile})` : `url(${HomeImg})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              // minHeight: '100vh',
              color: "white",
              position: "relative",
            }}
          >
            {/* AppBar */}
            <AppBar position="static" color="transparent" elevation={0} 
            style={{
              paddingTop:isMobile&&"23px"
              }}>
              <Toolbar
                style={{ justifyContent: "space-around", marginTop: isMobile?"30px":"50px" }}
              >
                <Box display="flex" alignItems="center">
                  <a
                    href="https://www.decorpot.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={Logo} alt="decorpot" className={classes?.logo} />
                  </a>
                </Box>

                <Hidden smDown>
                  <Box
                    className={classes?.navItems}
                    style={{
                      position: "relative",
                      zIndex: 1000,
                    }}
                  >
                    {navItems.map((item) => (
                      <Button
                        key={item.id}
                        component="a"
                        href={`#${item.id}`}
                        color="inherit"
                        style={{
                          textTransform: "none",
                          fontWeight: "600",
                          fontSize: isNestHub ? "10px" :"17px"
                          
                        }} // optional, keeps original casing
                      >
                        {item.name}
                      </Button>
                    ))}

                     <Tooltip title="Download PDF" placement="top" style={{ marginLeft: 10 }}>
                    <Button
                      component="a"
                      color="inherit"
                      style={{
                        textTransform: "none",
                        fontWeight: "600",
                         fontSize: isNestHub ? "10px" :"17px"
                      }} 
                      onClick={() => window.open(quotationInfo?.s3Location)}
                    >
                      <DescriptionIcon />
                    </Button>
                    </Tooltip>

                    {quotationInfo?.salesQuotation !=="" &&<Tooltip title="Customer App" placement="top" style={{ marginLeft: 10 }}>
                    <Button
                      component="a"
                      color="inherit"
                      style={{
                        textTransform: "none",
                        fontWeight: "600",
                         fontSize: isNestHub ? "10px" :"17px"
                      }} 
                      onClick={() => {
                        setTimeout(() => {
                          if (user === "erpUser") {
                            window.location.href = `/project-logs/${leadId}`;
                          }
                          if (user === "cx") {
                            webQuotationCloseActivityFun(leadId, versionNo);
                            window.location.href = `/cx_customer/dashboard`;
                          }
                        }, 300);
                      }}
                    >
                      <Dashboard /> 
                    </Button>
                  </Tooltip>}

                    <Tooltip title="Logout" placement="top" style={{ marginLeft: 10 }}>
                    <Button
                      component="a"
                      color="inherit"
                      style={{
                        textTransform: "none",
                        fontWeight: "600",
                         fontSize: isNestHub ? "10px" :"17px"
                      }} 
                      onClick={() => {
                        setTimeout(() => {
                          if (user === "erpUser") {
                            window.location.href = `/project-logs/${leadId}`;
                          }
                          if (user === "cx") {
                            webQuotationCloseActivityFun(leadId, versionNo);
                            if (wasOpenedByScript()) {
                                localStorage.clear();
                            } else {
                              localStorage.clear();
                              history.push("/user-login");
                              const encoded = btoa(`${leadId}/${versionNo}`);
                              localStorage.setItem(
                                "redirectTo",
                                `/webQuotation/cx/${encoded}`
                              );
                            }
                          }
                        }, 300);
                      }}
                    >
                      <ExitToApp />
                    </Button>
                    </Tooltip>

                  </Box>
                </Hidden>

                <Hidden mdUp>
                  <IconButton
                    edge="end"
                    color="inherit"
                    onClick={() => setDrawerOpen(true)}
                  >
                    <MenuIcon />
                  </IconButton>
                </Hidden>
              </Toolbar>
            </AppBar>

            {/* Drawer for mobile */}
            <Drawer
              anchor="right"
              open={drawerOpen}
              onClose={() => setDrawerOpen(false)}
            >
              <List style={{ width: 250 }}>
                {navItems.map((item) => (
                  <ListItem
                    button
                    key={item.id}
                    component="a"
                    href={`#${item.id}`} 
                    onClick={() => setDrawerOpen(false)}
                  >
                    <ListItemText primary={item.name} />
                  </ListItem>
                ))}

                  <ListItem
                  button
                  component="a"
                  onClick={() => window.open(quotationInfo?.s3Location)}
                >
                  <ListItemText primary="Download PDF" />
                </ListItem>
                
                {quotationInfo?.salesQuotation !=="" &&<ListItem
                  button
                  component="a"
                  onClick={() => {
                    setTimeout(() => {
                      if (user === "erpUser") {
                        window.location.href = `/project-logs/${leadId}`;
                      }
                      if (user === "cx") {
                        webQuotationCloseActivityFun(leadId, versionNo);
                        window.location.href = `/cx_customer/dashboard`;
                      }
                    }, 300);
                  }}
                >
                  <ListItemText primary="Dashboard" />
                </ListItem>
                  }

                <ListItem
                  button
                  component="a"
                  onClick={() => {
                    setTimeout(() => {
                      if (user === "erpUser") {
                        window.location.href = `/project-logs/${leadId}`;
                      }
                      if (user === "cx") {
                        webQuotationCloseActivityFun(leadId, versionNo);
                        if (wasOpenedByScript()) {
                            localStorage.clear();
                        } else {
                          localStorage.clear();
                          history.push("/user-login");
                          const encoded = btoa(`${leadId}/${versionNo}`);
                          localStorage.setItem(
                            "redirectTo",
                            `/webQuotation/cx/${encoded}`
                          );
                        }
                      }
                    }, 300);
                  }}
                >
                  <ListItemText primary="Logout" />
                </ListItem>

              </List>
            </Drawer>

            {/* Hero Content */}
            <Box
              className={classes?.heroContent}              
              style={{
                ...(isMobile && {
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }),
                marginTop: isMobile ? "100px" : "250px",
              }}
            >
              <Box style={{ display: "flex" }}>
                {" "}
                <div
                  style={{
                    width: "25px",
                    height: "2px",
                    background: "#FFFFFF",
                    marginTop: "13px",
                  }}
                />
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  style={{ marginLeft: isMobile?"3px":"5px", fontWeight: 600 }}
                >
                  {" "}
                  Hi {quotationInfo?.customer?.name}
                </Typography>{" "}
              </Box>

              <Typography
                variant={isMobile ? "h5" : "h3"}
                style={{ fontWeight: "bold", marginTop:isMobile && "10px" }}
                gutterBottom
              >
                YOUR DREAM HOME.
                <br />
                DESIGNED HONESTLY.
              </Typography>
              <Typography
                variant="body1"
                paragraph
                style={{ fontSize: !isMobile && "18px" , marginTop:isMobile && "10px" , textAlign: isMobile &&"center"}}
              >
                Transparent pricing, no compromises. See what we’ve planned for
                your space.
              </Typography>
              <Box
                display="flex"
                flexDirection="row"
                flexWrap="wrap"
                gridGap={16}
                style={{marginTop:isMobile && "10px"}}
              >
                <Button
                  variant="outlined"
                  className={classes?.buttonWhite}
                  href="#cost-summary"
                  style={{ marginLeft: isMobile && "22%", fontWeight: 600}}
                >
                  View Cost Summary
                </Button>
                <Button
                  variant="contained"
                  className={classes?.buttonPrimary}
                  href="#cost-breakdown"
                  style={{ marginLeft: isMobile && "17%", fontWeight: 600 }}
                >
                  View Project Breakdown
                </Button>
              </Box>
            </Box>
          </Box>

          {/* Below Hero Section      */}
          <Box
            sx={{
              py: 6,
              px: { xs: 2, md: 8 },
              backgroundColor: "#f5f5f5",
              color: "black",
            }}
            id="overview"
            style={{ paddingLeft: isMobile ? "0" : "5%" }}
          >
            <Grid container alignItems="center" spacing={isMobile ? 4 : 0}>
              {/* LEFT COLUMN - Stats */}
              <Grid item xs={12} md={7}>
                <Grid
                  container
                  alignItems="center"
                  justifyContent={isMobile ? "center" : "space-between"}
                  direction={isMobile ? "column" : "row"}
                  spacing={isMobile ? 3 : 0}
                >
                  {stats.map((stat, index) => (
                    <React.Fragment key={stat.label}>
                      <Box
                        sx={{
                          textAlign: "center",
                          px: isMobile ? 0 : 2,
                          mt: isMobile && 4,
                        }}
                      >
                        <Typography
                          variant="h3"
                          sx={{ fontWeight: "bold", color: "#1C093C" }}
                        >
                          {stat.value}
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{
                            color: "rgba(0,0,0,0.6)",
                            mt: 1,
                            fontSize: "1rem",
                          }}
                        >
                          {stat.label}
                        </Typography>
                      </Box>

                      {/* Divider for desktop only */}
                      {!isMobile && index < stats.length - 1 && (
                        <Divider
                          orientation="vertical"
                          flexItem
                          sx={{
                            borderColor: "rgba(0,0,0,0.1)",
                            height: "50px",
                          }}
                        />
                      )}
                    </React.Fragment>
                  ))}
                </Grid>
              </Grid>

              {/* RIGHT COLUMN - Text */}
              <Grid
                item
                xs={12}
                md={5}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center", 
                  alignItems: isMobile ? "center" : "flex-start", 
                  textAlign: isMobile ? "center" : "left",
                  marginTop: isMobile ? "32px" : "0", 
                  paddingLeft: isMobile ? "" : "48px", 
                  height: "100%",
                }}
              >
                <Typography
                  variant="h6"
                  style={{
                    fontWeight: "bold",
                    color: "#1C093C",
                    marginBottom: "8px",
                  }}
                >
                  More Than Just Interiors.
                  <br />A Partner You Can Trust.
                </Typography>
                <Typography
                  variant="body2"
                  style={{
                    color: "rgba(0,0,0,0.6)",
                    width: isMobile ? "100%" : "60%",
                    margin: isMobile ? "0 auto" : "0",
                    padding: isMobile && "0 7%",
                    fontSize: "15px",
                    fontWeight: "600",
                  }}
                >
                  With over 10,000 homes crafted, Decorpot delivers what others
                  only promise honest pricing, premium materials, and zero
                  compromise.
                </Typography>
              </Grid>
            </Grid>
          </Box>

           {/* Main Summary Section     */}  

           <Box id="cost-summary" >  
           <Box
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                paddingTop: "10px",                
              }}
            >
              <div
                style={{
                  width: "100px",
                  height: "3px",
                  background: "#d3d3d3",
                  margin: isMobile ? "0 auto 16px" : "0 0 16px",

                }}
              />

              <h2
                style={{
                  margin: "0 0 12px",
                  fontWeight: 600,
                  color: "#130B38",
                  textAlign: isMobile ? "center" : "left",
                }}
              >
                <span style={{ color: "#FF7A45" }}>Summary*</span>
              </h2>
            </Box>
            <Typography
              variant="body1"
              className={classes?.subHeading}
              style={{ fontWeight: "600", fontSize: isMobile?"10":"17px", marginBottom:"10px", textAlign: "center", }}
            >
              Here’s what we’ve thoughtfully planned for your home, room by room
            </Typography>

           <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              padding: "40px 0",
              background: "#ffffff",
            }}
          >
            <div
              style={{
                width: isMobile ? "90%":"78%", //100%
                border: "1px solid #ddd",
                borderRadius: "12px",
                overflow: "hidden",
                //  border:"2px solid green"
              }}
            >
              {quotationInfo?.components?.map((row, index) => (
                <div
                  key={index}
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                  }}
                >
                  <div
                    style={{
                      background: "#E47E46",
                      color: "white",
                      padding: "14px 20px",
                      fontSize: "15px",
                      fontWeight: 600,
                      borderBottom: "1px solid rgba(255,255,255,0.3)",
                    }}
                  >
                    {row?.categoryDetails?.name}{" "}
                  </div>

                  <div
                    style={{
                      padding: "14px 20px",
                      textAlign: "right",
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    <div
                      style={{
                        color: "#d32f2f",
                        fontWeight: 600,
                        fontSize: "14px",
                        textDecoration:
                        quotationInfo?.discountPercent > 0
                          ? "line-through"
                          : null,
                      }}
                    >
                      ₹ {formatToINR(Number(row?.categoryDetails?.totalPrice || 0).toFixed(2))}
                    </div>
                    {
                      quotationInfo?.discountPercent > 0 && <div
                      style={{
                        color: "#2e7d32",
                        fontWeight: 600,
                        fontSize: "14px",
                      }}
                    >
                    ₹ {formatToINR(
                      Number(
                        discountCalculationFun(
                          row?.categoryDetails?.totalPrice || 0,
                          quotationInfo?.discountPercent || 0
                        ).toFixed(2)
                      )
                    )}

                    </div>
                    }
                  </div>
                </div>
              ))}

              {/* Footer Section */}
              <div
                style={{
                  display: !isMobile &&"grid",
                  gridTemplateColumns: !isMobile && "1fr 1fr",
                }}
              >
               {!isMobile && <div style={{ background: "#E47E46", minHeight: "100%" }}></div>}

                <div style={{ padding: "16px 20px", fontSize: "14px" }}>
                  {/* Row */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "6px 0",
                    }}
                  >
                    <span style={{fontSize:"16px", color: "gray",fontWeight: 800}}>Total Quotation Value</span>
                    <span style={{ color: "#2e7d32", fontWeight: 800, fontSize:"16px" }}>₹ {formatToINR(Number(quotationInfo?.totalAmount || 0).toFixed(2))}

                    </span>
                  </div>

                  {quotationInfo?.discountPercent > 0 &&<div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "6px 0",
                    }}
                  >
                    <span style={{fontSize:"16px", color: "gray",fontWeight: 800}}>Discount @ {quotationInfo?.discountPercent}%</span>
                    <span style={{ color: "#2e7d32", fontWeight: 800, fontSize:"16px" }}>
                    ₹ {formatToINR(
                        Number(
                          ((quotationInfo?.totalAmount || 0) * (quotationInfo?.discountPercent || 0)) / 100
                        ).toFixed(2)
                      )}
                      </span>
                  </div>
                  }
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "6px 0",
                    }}
                  >
                    <span style={{fontSize:isMobile?"":"16px",  color: "gray", fontWeight: 800}}>Sub Total</span>
                    <span style={{ color: "#2e7d32", fontWeight: 800, fontSize:isMobile?"":"16px" }}>
                    ₹ {formatToINR(
                        (
                          Number(quotationInfo?.totalAmount || 0) -
                          (Number(quotationInfo?.totalAmount || 0) * Number(quotationInfo?.discountPercent || 0)) / 100
                        ).toFixed(2)
                      )}
                      </span>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "6px 0",
                    }}
                  >
                    <span style={{fontSize:isMobile?"":"16px",  color: "gray", fontWeight: 800}}>GST @ {quotationInfo?.taxPercent}%</span>
                    <span style={{ color: "#2e7d32", fontWeight: 800, fontSize:isMobile?"":"16px" }}>                        
                    ₹ {formatToINR(
                        gstCalculationFun(
                          Number(quotationInfo?.totalAmount || 0) -
                            (Number(quotationInfo?.totalAmount || 0) * Number(quotationInfo?.discountPercent || 0)) / 100,
                          Number(quotationInfo?.taxPercent || 0)
                        ).toFixed(2)
                      )}
                      </span>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "6px 0",
                      fontWeight: 700,
                    }}
                  >
                    <span style={{fontSize:isMobile?"":"16px",  color: "gray", fontWeight: 800}}>Total</span>

                    {quotationInfo?.discountPercent > 0 ? (
                      <span style={{ color: "#2e7d32", fontWeight: 800, fontSize:isMobile?"":"16px" }}>
                        ₹{" "}
                        {formatToINR(
                          (
                            (quotationInfo?.totalAmount -
                              (quotationInfo?.totalAmount * quotationInfo?.discountPercent) / 100) +
                            gstCalculationFun(
                              quotationInfo?.totalAmount -
                                (quotationInfo?.totalAmount * quotationInfo?.discountPercent) / 100,
                              quotationInfo?.taxPercent
                            )
                          ).toFixed(2)
                        )}
                      </span>
                    ) : (
                      <span style={{ color: "#2e7d32", fontWeight: 800, fontSize:isMobile?"":"16px"}}>
                        ₹{" "}
                        {formatToINR(
                          (
                            quotationInfo?.totalAmount +
                            gstCalculationFun(
                              quotationInfo?.totalAmount,
                              quotationInfo?.taxPercent
                            )
                          ).toFixed(2)
                        )}
                      </span>
                    )}
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0 0 0",
                      fontWeight: 700,
                      borderTop: "1px solid #ccc",
                    }}
                  >
                    <span style={{fontSize:isMobile?"":"16px", color: "gray",}}>Total Customer Outflow</span>
                    {quotationInfo?.discountPercent > 0 ? (
                        <span style={{ color: "#1b5e20", fontWeight: 800, fontSize:isMobile?"":"17px" }}>
                          ₹{" "}
                          {formatToINR(
                            (
                              (
                                quotationInfo?.totalAmount -
                                (quotationInfo?.totalAmount * quotationInfo?.discountPercent) / 100
                              ) +
                              gstCalculationFun(
                                quotationInfo?.totalAmount -
                                  (quotationInfo?.totalAmount * quotationInfo?.discountPercent) / 100,
                                quotationInfo?.taxPercent
                              )
                            ).toFixed(2)
                          )}
                        </span>
                      ) : (
                        <span style={{ color: "#1b5e20", fontWeight: 800, fontSize:isMobile?"":"17px" }}>
                          ₹{" "}
                          {formatToINR(
                            (
                              quotationInfo?.totalAmount +
                              gstCalculationFun(
                                quotationInfo?.totalAmount,
                                quotationInfo?.taxPercent
                              )
                            ).toFixed(2)
                          )}
                        </span>
                      )}
                    {/* <span style={{ color: "#1b5e20", fontWeight: 800 }}>₹15,01,949.11</span> */}
                  </div>
                </div>
              </div>
            </div>
           </div>                    
           </Box>         
          {/* Cost Summary Section     */}

          <Box
            style={{
              textAlign: "center",
              // padding: themes.spacing(6, 2),
              padding: "1% 7%",
              backgroundColor: "#FAFAFA",
            }}
          >
            {/* Heading */}
            <Typography
              variant="body1"
              className={classes?.subHeading}
              style={{ fontWeight: "600", fontSize: "13px", marginBottom:"10px" }}
            >
              Images are representative and not an actual design of the customer’s space
            </Typography>
            {/* Carousel */}
            {isMobile ? (
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                  marginTop: 45,
                  overflow: "hidden",
                }}
              >
                {/* Slider */}
                <Box
                  style={{ width: "100%", maxWidth: 800, overflow: "hidden" }}
                >
                  <Box
                    style={{
                      display: "flex",
                      transform: `translateX(-${pageCostSummary * 100}%)`,
                      transition: "transform 0.6s ease-in-out",
                      width: "100%",
                    }}
                  >
                    {quotationInfo?.components?.map((item) => (
                      <Box
                        key={item.id}
                        style={{
                          flex: "0 0 100%",
                          maxWidth: "100%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Card
                          // key={i}
                          className={classes?.card}
                          style={{
                            width: "100%",
                          }}
                        >
                          {costSummaryImages?.map(
                            (category) =>
                              category?.title ===
                                item?.categoryDetails?.name && (
                                <React.Fragment key={category?.title}>
                                  <CardMedia
                                    style={{ height: 200 }}
                                    image={category?.imageUrl}
                                  />
                                </React.Fragment>
                              )
                          )}
                            <div
                            style={{
                                background: "#fff",
                                borderRadius: "8px",
                                boxShadow: "0 1px 3px rgba(28,55,93,0.08)",
                                padding: "20px",
                                maxWidth: "420px",
                                // display: "flex",
                                // alignItems: "center",
                                // justifyContent: "space-between",
                                gap: "12px",
                            }}
                            >
                            <h3
                                style={{
                                margin: 0,
                                fontSize: "1.125rem",
                                lineHeight: 1.2,
                                fontWeight: 600,
                                color: "#1C375D", // dark blue from your palette
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                }}
                            >
                                {item?.categoryDetails?.name ?? "—"}
                            </h3>

                            <button
                                style={{
                                appearance: "none",
                                border: "none",
                                padding: "12px 20px",
                                borderRadius: "8px",
                                fontWeight: 600,
                                fontSize: "0.95rem",
                                cursor: "pointer",
                                backgroundColor: "#F47E46", // Decorpot Orange
                                color: "#fff",
                                boxShadow: "0 2px 6px rgba(244,126,70,0.18)",
                                transition: "all 0.2s ease-in-out",
                                marginTop:"15px"
                                }}
                                onMouseOver={(e) => {
                                e.currentTarget.style.transform = "translateY(-1px)";
                                e.currentTarget.style.boxShadow = "0 4px 10px rgba(28,55,93,0.12)";
                                }}
                                onMouseOut={(e) => {
                                e.currentTarget.style.transform = "translateY(0)";
                                e.currentTarget.style.boxShadow = "0 2px 6px rgba(244,126,70,0.18)";
                                }}
                            >
                                ₹ {formatToINR(Number(item?.categoryDetails?.totalPrice || 0).toFixed(2))}
                            </button>
                            </div>

                        </Card>
                      </Box>
                    ))}
                  </Box>
                </Box>

                {/* Controls (arrows + dots together) */}
                {quotationInfo?.components?.length > 1 && (
                  <Box
                    style={{
                      marginTop: 24,
                      display: "flex",
                      alignItems: "center",
                      gap: 16,
                      justifyContent: "space-around",
                      width: "100%",
                    }}
                  >
                    {/* Left Arrow */}
                    <IconButton
                      style={{
                        transform: "translateY(-50%)",
                        background: "white",
                        border: "1px solid #ccc",
                        borderRadius: "50%",
                        width: 40,
                        marginTop: "50px",
                        height: 40,
                      }}
                      onClick={goPrevCostSummary}
                      disabled={pageCostSummary === 0}
                    >
                      <ArrowBackIos />
                    </IconButton>

                    {/* Dots */}
                    <Box
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: 8,
                      }}
                    >
                      {quotationInfo?.components?.map((_, index) => (
                        <span
                          key={index}
                          onClick={() => setPageCostSummary(index)}
                          style={{
                            height: 10,
                            width: 10,
                            borderRadius: "50%",
                            cursor: "pointer",
                            backgroundColor:
                              pageCostSummary === index ? "#f47e46" : "#ccc",
                          }}
                        />
                      ))}
                    </Box>

                    {/* Right Arrow */}
                    <IconButton
                      style={{
                        transform: "translateY(-50%)",
                        background: "white",
                        border: "1px solid #ccc",
                        borderRadius: "50%",
                        width: 40,
                        height: 40,
                        marginTop: "50px",
                      }}
                      onClick={goNextCostSummary}
                      disabled={
                        pageCostSummary ===
                        quotationInfo?.components?.length - 1
                      }
                    >
                      <ArrowForwardIos />
                    </IconButton>
                  </Box>
                )}
              </Box>
            ) : (
              <Box
                style={{
                  position: "relative",
                  overflow: "hidden",
                  height: "400px",
                  display: quotationInfo?.components?.length < 4 && "flex",
                  justifyContent: quotationInfo?.components?.length && "center",
                }}
              >
                <Box
                  style={{
                    display: "flex",
                    transition: "transform 0.5s ease",
                    justifyContent: "center",
                    transform: `translateX(-${
                      (currentIndex / quotationInfo?.components?.length) * 100
                    }%)`,
                    width: `${
                      (quotationInfo?.components?.length / visibleCards) * 100
                    }%`,
                  }}
                >
                  {quotationInfo?.components?.map((item, i) => (
                    <Card
                      className={classes?.card}
                      style={{
                        width: "100%",
                      }}
                    >
                      {costSummaryImages?.map(
                        (category) =>
                          category?.title === item?.categoryDetails?.name && (
                            <React.Fragment key={category?.title}>
                              <CardMedia
                                style={{ height: 200 }}
                                image={category?.imageUrl}
                              />
                            </React.Fragment>
                          )
                      )}
                      <CardContent>
                        <Typography variant="h6" style={{ fontWeight: 600 }}>
                          {item?.categoryDetails?.name}{" "}
                        </Typography>
                        <Button variant="contained" className={classes?.button}>
                          ₹ {formatToINR(Number(item?.categoryDetails?.totalPrice).toFixed(2))}{" "}
                        </Button>
                      </CardContent>
                    </Card>
                  ))}
                </Box>

                {/* Arrows + Dots */}
                {quotationInfo?.components?.length > 3 && (
                  <>
                    <IconButton
                      onClick={handlePrev}
                      className={classes?.arrows}
                      style={{ left: 0, top: isMobile ? "90%" : "33%" }}
                    >
                      <ArrowBackIos fontSize="small" />
                    </IconButton>

                    <IconButton
                      onClick={handleNext}
                      className={classes?.arrows}
                      style={{ right: 0, top: isMobile ? "90%" : "33%" }}
                    >
                      <ArrowForwardIos fontSize="small" />
                    </IconButton>

                    {/* Dots */}
                    <Box
                      className={classes?.dots}
                      style={{ marginTop: isMobile ? "30px" : "" }}
                    >
                      {Array.from({ length: totalPages }).map((_, i) => (
                        <span
                          key={i}
                          onClick={() => setCurrentIndex(i * visibleCards)} // jump to page
                          className={`${classes?.dot} ${
                            i === Math.floor(currentIndex / visibleCards)
                              ? classes?.dotActive
                              : ""
                          }`}
                        />
                      ))}
                    </Box>
                  </>
                )}
              </Box>
            )}

            {/* Bottom Section */}
            <Box
              style={{
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                borderRadius: 8,
                overflow: "hidden",
                border: "1px solid #eee",
                marginTop: "20px",
              }}
              id="projectQuote"
            >
              {/* Left Section */}
              <Box
                style={{
                  flex: isMobile ? "unset" : 2,
                  background: "#fff",
                  padding: 24,
                  position: "relative",
                }}
              >
                {/* Orange strip → top on mobile, left on desktop */}
                <Box
                  style={{
                    background: "#F47E46",
                    height: isMobile ? 12 : "100%",
                    width: isMobile ? "100%" : 12,
                    position: "absolute",
                    top: 0,
                    left: 0,
                  }}
                />

                <Box
                  style={{
                    marginLeft: isMobile ? 0 : 24,
                    marginTop: isMobile ? 24 : 0,
                  }}
                >
                  <Typography
                    style={{
                      fontWeight: "bold",
                      fontSize: "1.2rem",
                      color: "#1C375D",
                      marginBottom: 8,
                      textAlign: "left",
                    }}
                  >
                    Your Total Quote:{" "}
                    <span
                      style={{
                        color: "#F47E46",
                        fontWeight: "bold",
                        // fontSize: "1.2rem",
                      }}
                    >
                      ₹  {quotationInfo?.discountPercent > 0 ? (
                        <Typography variant="p" style={{}}>
                          {formatToINR(Number(
                        (
                         quotationInfo?.totalAmount -
                        (quotationInfo?.totalAmount *
                        quotationInfo?.discountPercent) /100) +
                            gstCalculationFun(
                                (
                                  quotationInfo?.totalAmount -
                                  (quotationInfo?.totalAmount *
                                    quotationInfo?.discountPercent) /
                                    100
                                ),
                                quotationInfo?.taxPercent
                              )
                          ).toFixed(2))}
                        </Typography>
                      ) : (
                        <Typography variant="p" style={{}}>
                          {formatToINR((Number(
                            quotationInfo?.totalAmount +
                            gstCalculationFun(
                              quotationInfo?.totalAmount,
                              quotationInfo?.taxPercent
                            )
                          ).toFixed(2)))}
                        </Typography>
                      )}
                    </span>
                  </Typography>

                  <div
                    style={{
                      width: isMobile ? "100%" : "200px",
                      height: "2px",
                      background: "#d3d3d3",
                      margin: isMobile ? "0 auto 16px" : "0 0 16px",
                    }}
                  />

                  <Typography
                    style={{
                      color: "#666",
                      marginTop: 16,
                      lineHeight: 1.5,
                      textAlign: "left",
                      fontWeight: "600",
                      fontSize: "17px",
                    }}
                  >
                 Most homeowners who choose Decorpot spend 10–15% less than market rates, while still getting premium finishes and lasting quality
                  </Typography>
                </Box>
              </Box>

              {/* Right Section */}
              <Box
                style={{
                  flex: isMobile ? "unset" : 1,
                  padding: 24,
                  background: "#F47E46",
                  color: "#fff",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: isMobile ? "0 0 8px 8px" : "0 8px 8px 0",
                }}
              >

              <Box style={{ textAlign: "center" }}>
                <Typography style={{ fontSize: "1.2rem", fontWeight: "bold" }}>
                  You Save:&nbsp;
                  <span style={{ fontWeight: "bold" }}>
                      ₹{" "}
                      {quotationInfo?.discountPercent > 0
                        ? formatToINR(
                            (
                              (Number(
                                quotationInfo?.totalAmount +
                                  gstCalculationFun(
                                    quotationInfo?.totalAmount,
                                    quotationInfo?.taxPercent
                                  )
                              ) *
                                15) /
                              100
                            ).toFixed(2)
                          )
                        : formatToINR(
                            (
                              (Number(
                                quotationInfo?.totalAmount +
                                  gstCalculationFun(
                                    quotationInfo?.totalAmount,
                                    quotationInfo?.taxPercent
                                  )
                              ) *
                                15) /
                              100
                            ).toFixed(2)
                          )}
                    </span>


                </Typography>

                <Typography
                  style={{
                    marginTop: 8,
                    fontWeight: 600,
                    fontSize: "17px",
                  }}
                >
                  Compared to market price
                </Typography>
              </Box>

              </Box>
            </Box>
          </Box>


          {/* why choose us Sections  */}

          <Box
            id="why-decorpot"
            style={{
              textAlign: "center",
              padding: "1% 7%",
              backgroundColor: "#FAFAFA",
              marginTop: "20px",
            }}
          >
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                paddingTop: "10px",
              }}
            >
              <div
                style={{
                  width: "100px",
                  height: "3px",
                  background: "#d3d3d3",
                  margin: isMobile ? "0 auto 16px" : "0 0 16px",
                }}
              />

              <h2
                style={{
                  margin: "0 0 12px",
                  fontSize: isMobile ? "24px" : "32px",
                  fontWeight: 600,
                  color: "#130B38",
                  textAlign: isMobile ? "center" : "left",
                }}
              >
                Why <span style={{ color: "#FF7A45" }}>us</span>
              </h2>
            </Box>
            <Typography
              variant="body1"
              style={{
                color: "rgba(0,0,0,0.5)",
                marginBottom: 32,
                maxWidth: 760,
                marginLeft: "auto",
                marginRight: "auto",
                fontSize: "17px",
                fontWeight: "600",
              }}
            >
              At Decorpot, trust isn’t just a word it’s the foundation of every
              home we design.
            </Typography>

            {isMobile ? (
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                  marginTop: 40,
                  overflow: "hidden",
                }}
              >
                {/* Slider */}
                <Box
                  style={{ width: "100%", maxWidth: 800, overflow: "hidden" }}
                >
                  <Box
                    style={{
                      display: "flex",
                      transform: `translateX(-${pageWhyChooseUs * 100}%)`,
                      transition: "transform 0.6s ease-in-out",
                      width: "100%",
                    }}
                  >
                    {whyChooseUsContent.length > 0 &&
                      whyChooseUsContent.map((item, currentIndex) => (
                        <Box
                          key={item.id}
                          style={{
                            flex: "0 0 100%",
                            maxWidth: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Card
                            className={classes?.card}
                            style={{
                              width: "100%",
                              borderRadius: 16,
                              boxShadow:
                                "0 8px 20px rgba(28,55,93,0.06), 0 2px 6px rgba(28,55,93,0.04)",
                              padding: 32,
                              textAlign: "center",
                              background: isHighlighted(currentIndex)
                                ? "#fff"
                                : "#fff",
                              color: isHighlighted(currentIndex) ? BLUE : BLUE,
                            }}
                          >
                            <CardContent>
                              <Box
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <CardMedia
                                  style={{ height: 100, width: 100 }}
                                  image={item.icon}
                                />
                              </Box>
                              <Typography
                                variant="h6"
                                style={{ fontWeight: 700, margin: "8px 0" }}
                              >
                                {item?.title}
                              </Typography>
                              <Typography
                                variant="body2"
                                style={{
                                  opacity: 0.9,
                                  fontSize: "15px",
                                  fontWeight: "600",
                                }}
                              >
                                {item?.subtitle}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Box>
                      ))}
                  </Box>
                </Box>

                {/* Controls (arrows + dots together) */}
                <Box
                  style={{
                    marginTop: 24,
                    display: "flex",
                    alignItems: "center",
                    gap: 16,
                    justifyContent: "space-around",
                    width: "100%",
                  }}
                >
                  {/* Left Arrow */}
                  <IconButton
                    style={{
                      transform: "translateY(-50%)",
                      background: "white",
                      border: "1px solid #ccc",
                      borderRadius: "50%",
                      width: 40,
                      marginTop: "50px",
                      height: 40,
                    }}
                    onClick={goPrevWhyChooseUs}
                    disabled={pageWhyChooseUs === 0}
                  >
                    <ArrowBackIos />
                  </IconButton>

                  {/* Dots */}
                  <Box
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      gap: 8,
                    }}
                  >
                    {whyChooseUsContent.map((_, index) => (
                      <span
                        key={index}
                        onClick={() => setPageWhyChooseUs(index)}
                        style={{
                          height: 10,
                          width: 10,
                          borderRadius: "50%",
                          cursor: "pointer",
                          backgroundColor:
                            pageWhyChooseUs === index ? "#f47e46" : "#ccc",
                        }}
                      />
                    ))}
                  </Box>

                  {/* Right Arrow */}
                  <IconButton
                    style={{
                      transform: "translateY(-50%)",
                      background: "white",
                      border: "1px solid #ccc",
                      borderRadius: "50%",
                      width: 40,
                      height: 40,
                      marginTop: "50px",
                    }}
                    onClick={goNextWhyChooseUs}
                    disabled={pageWhyChooseUs === whyChooseUsContent.length - 1}
                  >
                    <ArrowForwardIos />
                  </IconButton>
                </Box>
              </Box>
            ) : (
              // --- Desktop Grid ---
              <Box
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(3, 1fr)",
                  gap: 24,
                  padding: "3% 0%",
                }}
              >
                {whyChooseUsContent.length > 0 &&
                  whyChooseUsContent.map((item, currentIndex) => (
                    <Card
                      key={currentIndex}
                      style={{
                        borderRadius: 16,
                        boxShadow:
                          "0 8px 20px rgba(28,55,93,0.06), 0 2px 6px rgba(28,55,93,0.04)",
                        padding: 32,
                        textAlign: "center",
                        minHeight: 300,
                        background: isHighlighted(currentIndex)
                          ? "#fff"
                          : "#fff",
                        color: isHighlighted(currentIndex) ? BLUE : BLUE,
                      }}
                    >
                      <CardContent>
                        <Box
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          <CardMedia
                            style={{ height: 100, width: 100 }}
                            image={item.icon}
                          />
                        </Box>
                        <Typography
                          variant="h6"
                          style={{ fontWeight: 700, margin: "8px 0" }}
                        >
                          {item.title}
                        </Typography>
                        <Typography
                          variant="body2"
                          style={{
                            opacity: 0.9,
                            fontSize: "15px",
                            fontWeight: "600",
                          }}
                        >
                          {item.subtitle}
                        </Typography>
                      </CardContent>
                    </Card>
                  ))}
              </Box>
            )}
          </Box>

          {/* Cost Breakdown Sections  */}

          <Box
            style={{
              maxWidth: "100%",
              padding: "0 7%",
              backgroundColor: "#FAFAFA",
            }}
            id="cost-breakdown"
          >
            {/* Heading */}
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                paddingTop: "10px",
              }}
            >
              <div
                style={{
                  width: "100px",
                  height: "3px",
                  background: "#d3d3d3",
                  margin: isMobile ? "0 auto 16px" : "0 0 16px",
                }}
              />

              <h2
                style={{
                  margin: "0 0 12px",
                  fontSize: isMobile ? "24px" : "32px",
                  fontWeight: 600,
                  color: "#130B38",
                  textAlign: isMobile ? "center" : "left",
                }}
              >
                 <span style={{ color: "#FF7A45" }}>Breakup</span>
              </h2>
            </Box>

            {/* Subtext */}
            <Typography
              variant="body1"
              style={{
                textAlign: "center",
                color: "#555",
                marginBottom: "32px",
                fontSize: "17px",
                fontWeight: "600",
              }}
            >
              See what you get, where it goes, and how every rupee is working
              for you.
            </Typography>

            {/* Accordions */}
            <Box>
              {accordionData.map((component, index) => (
                <Accordion
                  key={component._id}
                  expanded={expanded === String(component?._id)}
                  onChange={handleChange(String(component?._id))}
                  style={{
                    backgroundColor: "#faf8f6",
                    boxShadow: "none",
                    border: "1px dashed #ccc",
                    marginBottom: "5px",
                  }}
                >
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography
                      style={{
                        width: "100%",
                        fontSize: "17px",
                        fontWeight: "600",
                      }}
                    >
                      {component?.categoryDetails.name}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails style={{ display: "block" }}>
                    <div
                      style={{
                        width: "100%",
                        height: "1px",
                        background: "#d3d3d3",
                        margin: isMobile ? "0 auto 16px" : "0 0 16px",
                      }}
                    />

                    {/* Example content (you can conditionally render different content per item) */}
                    <Box>
                      <Box>
                        {costBreakDownImages?.map(
                          (category) =>
                            category?.title ===
                              component?.categoryDetails?.name && (
                              <img
                                src={category?.imageUrl}
                                alt="Services"
                                style={{
                                  maxWidth: "100%", 
                                  height: "auto", 
                                  display: "block", 
                                }}
                              />
                            )
                        )}
                      </Box>

                      {/* Table */}
                      <Box style={{ overflowX: "auto", marginTop: "0px" }}>
                        <table
                          style={{
                            width: "100%",
                            borderCollapse: "collapse",
                            border: "1px dashed #ccc",
                          }}
                        >
                          {/* Table Head */}
                          <thead>
                            <tr
                              style={{
                                backgroundColor: "#f36f21",
                                color: "#fff",
                              }}
                            >
                              <th style={headerStyle}>Particulars</th>
                              <th style={headerStyle}>Core Material</th>
                              <th style={headerStyle}>Finish Type</th>
                              <th style={headerStyle}>Area/Qty (In Sq.Ft)</th>
                              <th style={headerStyle}>Cost (Per Sq.Ft/Qty)</th>
                              <th style={headerStyle}>Total Cost</th>
                            </tr>
                          </thead>

                          {/* Table Body */}

                          {component.products.map((product, index) => {
                            return (
                              <tbody>
                                <tr style={{ textAlign: "center" }}>
                                  <td style={cellStyle}>
                                    {product?.product}
                                  </td>
                                  <td style={cellStyle}>
                                    {" "}
                                    <td style={cellStyle}>
                                      {(product?.subUnitType === "Area" || product?.subUnitType === "area") && product.plyInclude === true
                                        ? (component?.categoryDetails?.name?.toUpperCase().includes("KITCHEN") ||
                                          component?.categoryDetails?.name?.toUpperCase().includes("UTILITY") ||
                                          component?.categoryDetails?.name?.toUpperCase().includes("VANITY") ||
                                          component?.categoryDetails?.name?.toUpperCase().includes("WASHROOM")) && product?.plyType?.name === "Plywood"
                                          ? "BWP Plywood"
                                          : product?.plyType?.name
                                        : "N/A"}
                                    </td>
                                  </td>
                                  <td style={cellStyle}>
                                    {" "}
                                    {(product?.subUnitType === "Area" || product?.subUnitType ==="area" ) &&
                                    product.finishInclude === true
                                      ? product?.finishType
                                      : "N/A"}
                                  </td>
                                  <td style={cellStyle}>
                                    {" "}
                                    {product?.area} <br />
                                    <span> ({product?.subUnitType}) </span>
                                  </td>
                                  {quotationInfo?.discountPercent > 0 && (
                                    <td
                                      style={{
                                        borderBottom: "none",
                                        fontWeight: "600",
                                      }}
                                    >
                                      <span
                                        style={{
                                          textDecoration: "line-through",
                                          color: "red",
                                        }}
                                      >
                                        {formatToINR(Number(product?.totalPricePerUnit.toFixed(
                                          2))
                                        )}
                                      </span>
                                      <br />
                                      <span style={{ color: "green" }}>
                                        {formatToINR(Number(discountCalculationFun(
                                          parseFloat(
                                            product?.totalPricePerUnit
                                          ) || 0,
                                          parseFloat(
                                            quotationInfo?.discountPercent
                                          ) || 0
                                        ).toFixed(2)))}
                                      </span>
                                    </td>
                                  )}

                                  {quotationInfo?.discountPercent < 1 && (
                                    <td
                                      style={{
                                        borderBottom: "none",
                                        fontWeight: "600",
                                      }}
                                    >
                                      <span style={{ color: "green" }}>
                                        {formatToINR(Number(product?.totalPricePerUnit.toFixed(
                                          2))
                                        )}
                                      </span>
                                    </td>
                                  )}

                                  {quotationInfo?.discountPercent > 0 && (
                                    <td
                                      style={{
                                        borderBottom: "none",
                                        fontWeight: "600",
                                      }}
                                    >
                                      <span
                                        style={{
                                          textDecoration: "line-through",
                                          color: "red",
                                          fontWeight: "600",
                                        }}
                                      >
                                        {formatToINR(Number(product?.productPrice))}
                                      </span>
                                      <br />
                                      <span
                                        style={{
                                          color: "green",
                                          fontWeight: "600",
                                        }}
                                      >
                                        {formatToINR(Number(discountCalculationFun(
                                          parseFloat(product?.productPrice) ||
                                            0,
                                          parseFloat(
                                            quotationInfo?.discountPercent
                                          ) || 0
                                        ).toFixed(2)))}
                                      </span>
                                    </td>
                                  )}
                                  {quotationInfo?.discountPercent < 1 && (
                                    <td
                                      style={{
                                        borderBottom: "none",
                                      }}
                                    >
                                      <span
                                        style={{
                                          color: "green",
                                          fontWeight: "600",
                                        }}
                                      >
                                       {formatToINR(Number(product?.productPrice).toFixed(2))}
                                      </span>
                                    </td>
                                  )}
                                </tr>
                              </tbody>
                            );
                          })}

                          {/* Total Row */}
                          <tfoot>
                            <tr style={{ textAlign: "right" }}>
                              <td colSpan="4" style={cellStyle}></td>
                              <td
                                style={{
                                  ...cellStyle,
                                  fontWeight: 600,
                                  fontSize: "17px",
                                }}
                              >
                                Total
                              </td>
                              {quotationInfo?.discountPercent > 0 && (
                                <td
                                  style={{
                                    borderBottom: "none",
                                    color: "white",
                                    fontWeight: "600",
                                  }}
                                >
                                  <span
                                    style={{
                                      textDecoration: "line-through",
                                      color: "red",
                                    }}
                                  >
                                    {formatToINR(Number(component?.categoryDetails?.totalPrice).toFixed(
                                      2)
                                    )}
                                  </span>
                                  <br />
                                  <span
                                    style={{
                                      color: "green",
                                      fontWeight: "600",
                                    }}
                                  >
                                    {formatToINR(Number(discountCalculationFun(
                                      parseFloat(
                                        component?.categoryDetails?.totalPrice
                                      ) || 0,
                                      parseFloat(
                                        quotationInfo?.discountPercent
                                      ) || 0
                                    ).toFixed(2)))}
                                  </span>
                                </td>
                              )}

                              {quotationInfo?.discountPercent < 1 && (
                                <td
                                  style={{
                                    borderBottom: "none",
                                    color: "green",
                                    fontWeight: "600",
                                  }}
                                >
                                  <span>
                                    {formatToINR(Number(component?.categoryDetails?.totalPrice).toFixed(
                                      2)
                                    )}
                                  </span>
                                </td>
                              )}
                            </tr>
                          </tfoot>
                        </table>
                      </Box>
                    </Box>
                  </AccordionDetails>
                </Accordion>
              ))}
            </Box>
          </Box>

          {/* Partners Sections */}
          <Box
            style={{
              padding: "3% 7%",
              marginTop: "50px",
              backgroundColor: "#f5f5f5",
            }}
          >
            <Box>
              <Typography
                style={{
                  fontWeight: 600,
                  fontSize: "1.5rem",
                  marginBottom: "24px",
                  display: "flex",
                  gap: "8px",
                }}
              >
                Our Partners <span style={{ color: "#f47e46" }}>→</span>
              </Typography>

              <Typography
              variant="body1"
              className={classes?.subHeading}
              style={{ fontWeight: "600", fontSize: "17px" }}
            >
              Every hinge, panel, and finish is backed by global and national leaders in quality. Our partnerships are a guarantee that what goes into your home has already earned the trust of millions.
            </Typography>
              
            </Box>

            {isMobile ? (
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                  marginTop: 40,
                  overflow: "hidden",
                }}
              >
                {/* Slider */}
                <Box
                  style={{ width: "100%", maxWidth: 800, overflow: "hidden" }}
                >
                  <Box
                    style={{
                      display: "flex",
                      transform: `translateX(-${pagePartners * 100}%)`,
                      transition: "transform 0.6s ease-in-out",
                      width: "100%",
                    }}
                  >
                    {partners.map((item) => (
                      <Box
                        key={item._id}
                        style={{
                          flex: "0 0 100%",
                          maxWidth: "100%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={item.imageUrl}
                          alt="partner-logo"
                          style={{
                            width: 300,
                            height: "auto",
                            objectFit: "contain",
                          }}
                        />
                      </Box>
                    ))}
                  </Box>
                </Box>

                {/* Controls (arrows + dots together) */}
                <Box
                  style={{
                    marginTop: 24,
                    display: "flex",
                    alignItems: "center",
                    gap: 16,
                    justifyContent: "space-around",
                    width: "100%",
                  }}
                >
                  {/* Left Arrow */}
                  <IconButton
                    style={{
                      transform: "translateY(-50%)",
                      background: "white",
                      border: "1px solid #ccc",
                      borderRadius: "50%",
                      width: 40,
                      marginTop: "50px",
                      height: 40,
                    }}
                    onClick={goPrevPartners}
                    disabled={pagePartners === 0}
                  >
                    <ArrowBackIos />
                  </IconButton>

                  {/* Dots */}
                  <Box
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      gap: 8,
                    }}
                  >
                    {partners.map((_, index) => (
                      <span
                        key={index}
                        onClick={() => setPagePartners(index)}
                        style={{
                          height: 10,
                          width: 10,
                          borderRadius: "50%",
                          cursor: "pointer",
                          backgroundColor:
                            pagePartners === index ? "#f47e46" : "#ccc",
                        }}
                      />
                    ))}
                  </Box>

                  {/* Right Arrow */}
                  <IconButton
                    style={{
                      transform: "translateY(-50%)",
                      background: "white",
                      border: "1px solid #ccc",
                      borderRadius: "50%",
                      width: 40,
                      height: 40,
                      marginTop: "50px",
                    }}
                    onClick={goNextPartners}
                    disabled={pagePartners === partners.length - 1}
                  >
                    <ArrowForwardIos />
                  </IconButton>
                </Box>
              </Box>
            ) : (
              <Grid container spacing={4} justifyContent="space-between">
                {partners?.length > 0 &&
                  partners.map((item, index) => (
                    <React.Fragment key={item._id || index}>
                      <Grid item style={{ textAlign: "center" }}>
                        <Box
                          style={{
                            width: "120px",
                            margin: "auto",
                            display: "flex",
                          }}
                        >
                          <img
                            src={item?.imageUrl}
                            alt="img"
                            style={{
                              width: "125%",
                              maxHeight: "100%",
                              objectFit: "contain",
                              display: "block",
                              // border:"2px solid red"
                            }}
                          />
                        </Box>
                      </Grid>
                    </React.Fragment>
                  ))}
              </Grid>
            )}
          </Box>

          {/* -----Gallery Sections------ */}
          <Box
            style={{
              padding: "0 7%",
              marginTop: "5%",
              backgroundColor: "#FAFAFA",
            }}
            id="gallery"
          >
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                paddingTop: "10px",
              }}
            >
              <div
                style={{
                  width: "100px",
                  height: "3px",
                  background: "#d3d3d3",
                  margin: isMobile ? "0 auto 16px" : "0 0 16px",
                }}
              />

              <h2
                style={{
                  margin: "0 0 12px",
                  fontSize: isMobile ? "24px" : "32px",
                  fontWeight: 600,
                  color: "#130B38",
                  textAlign: isMobile ? "center" : "left",
                }}
              >
                Our <span style={{ color: "#FF7A45" }}>Gallery</span>
              </h2>
            </Box>
            {/* Gallery Desktop View */}
            {!isMobile &&
              galleryImages.length > 0 &&
              galleryImages.slice(0, visibleCount).map((ele, index) => {
                const isEven = index % 2 !== 0;

                return (
                  <Box
                    key={ele?._id}
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr 1fr",
                      gridTemplateRows: "auto auto auto",
                      gap: 2,
                      marginBottom: "40px",
                    }}
                  >
                    {/* TEXT Area */}
                    <Box
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box
                        sx={{
                          gridColumn: isEven ? "2 / 4" : "1 / 3",
                          gridRow: "1 / 2",
                          bgcolor: "#f5f5f5",
                          p: 2,
                          width: "100%",
                        }}
                      >
                        {/* Title and Edit/Delete Buttons in one row */}
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            mb: 1,
                          }}
                        >
                          <Typography
                            variant="h4"
                            style={{
                              color: "#1C375D",
                              padding: "5%",
                              paddingBottom: "2%",
                            }}
                          >
                            {ele?.title}
                          </Typography>
                        </Box>

                        {/* Description */}
                        <Typography
                          variant="body1"
                          style={{
                            color: "#555",
                            lineHeight: 1.6,
                            borderRight: "2px solid gray",
                            width: "100%",
                            padding: "5%",
                            fontWeight: "600",
                            fontSize: "17px",
                          }}
                        >
                          {ele?.description}
                        </Typography>
                      </Box>
                    </Box>

                    {/* IMG 1 - tall */}
                    <Box
                      sx={{
                        gridColumn: isEven ? "3 / 4" : "1 / 2",
                        gridRow: "1 / 3",
                      }}
                    >
                      <img
                        src={ele?.images[0]}
                        alt="img1"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </Box>

                    {/* IMG 3 - tall */}
                    <Box
                      sx={{
                        gridColumn: isEven ? "1 / 2" : "3 / 4",
                        gridRow: "2 / 4",
                      }}
                    >
                      <img
                        src={ele.images[2]}
                        alt="img3"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </Box>

                    {/* IMG 2 */}
                    <Box
                      sx={{
                        gridColumn: "2 / 3",
                        gridRow: "2 / 3",
                      }}
                    >
                      <img
                        src={ele.images[1]}
                        alt="img2"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </Box>

                    {/* IMG 5 */}
                    <Box
                      sx={{
                        gridColumn: "2 / 3",
                        gridRow: "3 / 4",
                      }}
                    >
                      <img
                        src={ele.images[4]}
                        alt="img5"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </Box>

                    {/* IMG 4 */}
                    <Box
                      sx={{
                        gridColumn: isEven ? "3 / 4" : "1 / 2",
                        gridRow: "3 / 4",
                      }}
                    >
                      <img
                        src={ele.images[3]}
                        alt="img4"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </Box>
                  </Box>
                );
              })}

            {/* Gallery Phone View */}
            {isMobile &&
              galleryImages?.slice(0, visibleCount).map((item) => {
                const images = item?.images || [];
                const currentIndex = pageGallery[item?.title] || 0;

                return (
                  <Box
                    key={item?._id || item?.title}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      marginTop: 40,
                      overflow: "hidden",
                    }}
                  >
                    {/* Title & description */}
                    <Box
                      style={{
                        width: "100%",
                        maxWidth: 800,
                        overflow: "hidden",
                      }}
                    >
                      <h2
                        style={{
                          fontSize: "22px",
                          fontWeight: "bold",
                          color: "#1c0d40",
                          marginBottom: "12px",
                        }}
                      >
                        {item?.title}
                      </h2>
                      <p
                        style={{
                          fontSize: "16px",
                          color: "#555",
                          lineHeight: "1.6",
                          marginBottom: "16px",
                          fontWeight: "600",
                          fontSize: "17px",
                        }}
                      >
                        {item?.description}
                      </p>

                      {/* Slider track */}
                      <Box
                        style={{
                          display: "flex",
                          transform: `translateX(-${
                            currentIndex * (100 / images.length)
                          }%)`,
                          transition: "transform 0.6s ease-in-out",
                          width: `${images.length * 100}%`,
                          height: "100%",
                        }}
                      >
                        {images.map((img, index) => (
                          <Box
                            key={index}
                            style={{
                              flex: `0 0 ${100 / images.length}%`,
                              boxSizing: "border-box",
                            }}
                          >
                            <Box
                              style={{
                                borderRadius: "12px",
                                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                                height: "300px", 
                                width: "100%", 
                                overflow: "hidden", 
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <img
                                src={img}
                                alt={`${item?.title}-${index}`}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover", 
                                }}
                              />
                            </Box>
                          </Box>
                        ))}
                      </Box>
                    </Box>

                    {/* Controls */}
                    <Box
                      style={{
                        marginTop: 20,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        maxWidth: 800,
                      }}
                    >
                      {/* Left Arrow */}
                      <IconButton
                        style={{
                          background: "white",
                          border: "1px solid #ccc",
                          borderRadius: "50%",
                          width: 40,
                          height: 40,
                        }}
                        onClick={() => goPrevGallery(item?.title)}
                        disabled={currentIndex === 0}
                      >
                        <ArrowBackIos />
                      </IconButton>

                      {/* Dots */}
                      <Box
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          gap: 8,
                        }}
                      >
                        {images.map((_, index) => (
                          <span
                            key={index}
                            onClick={() => handleDotClick(item?.title, index)}
                            style={{
                              height: 10,
                              width: 10,
                              borderRadius: "50%",
                              cursor: "pointer",
                              backgroundColor:
                                currentIndex === index ? "#f47e46" : "#ccc",
                            }}
                          />
                        ))}
                      </Box>

                      {/* Right Arrow */}
                      <IconButton
                        style={{
                          background: "white",
                          border: "1px solid #ccc",
                          borderRadius: "50%",
                          width: 40,
                          height: 40,
                        }}
                        onClick={() =>
                          goNextGallery(item?.title, images.length)
                        }
                        disabled={currentIndex === images.length - 1}
                      >
                        <ArrowForwardIos />
                      </IconButton>
                    </Box>
                  </Box>
                );
              })}

            <Box style={{ display: "flex", justifyContent: "center" }}>
              {visibleCount < galleryImages.length && (
                <button
                  onClick={handleShowMore}
                  style={{
                    background: "white",
                    color: "#4a4a64",
                    border: "1px solid #4a4a64",
                    borderRadius: "30px",
                    padding: "10px 24px",
                    fontSize: "16px",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    marginTop: isMobile ? "60px" : "",
                  }}
                  onMouseOver={(e) => (e.target.style.background = "#f7f7f7")}
                  onMouseOut={(e) => (e.target.style.background = "white")}
                >
                  View More
                </button>
              )}
              {!(visibleCount < galleryImages.length) &&
                galleryImages.length > 2 && (
                  <button
                    onClick={() => {
                      setVisibleCount(2);
                    }}
                    style={{
                      background: "white",
                      color: "#4a4a64",
                      border: "1px solid #4a4a64",
                      borderRadius: "30px",
                      padding: "10px 24px",
                      fontSize: "16px",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      marginTop: isMobile ? "60px" : "",
                    }}
                    onMouseOver={(e) => (e.target.style.background = "#f7f7f7")}
                    onMouseOut={(e) => (e.target.style.background = "white")}
                  >
                    View Less
                  </button>
                )}
            </Box>
          </Box>

          {/* -----Testimonials Sections------ */}

          <Box
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              marginTop: 40,
              overflow: "hidden",
              padding: "0 7%",
            }}
            id="testimonial"
          >
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                paddingTop: "10px",
              }}
            >
              <div
                style={{
                  width: "100px",
                  height: "3px",
                  background: "#d3d3d3",
                  margin: isMobile ? "0 auto 16px" : "0 0 16px",
                }}
              />

              <h2
                style={{
                  margin: "0 0 12px",
                  fontSize: isMobile ? "24px" : "32px",
                  fontWeight: 600,
                  color: "#130B38",
                  textAlign: isMobile ? "center" : "left",
                }}
              >
                Customer <span style={{ color: "#FF7A45" }}>Testimonials</span>
              </h2>
            </Box>

            <Box
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                position: "relative",
              }}
            >
              {/* Left Arrow */}
              {!isMobile && (
                <IconButton
                  onClick={goPrevTestimonial}
                  disabled={pageTestimonial === 0}
                  style={{
                    position: "absolute",
                    top: isMobile ? "100%" : "50%",
                    left: 40,
                    transform: "translateY(-50%)",
                    border: "1px solid #aaa",
                    background: "transparent",
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
                  }}
                >
                  <ArrowBackIos />
                </IconButton>
              )}
              {/* Slider */}
              <Box style={{ width: "100%", maxWidth: 800, overflow: "hidden" }}>
                <Box
                  style={{
                    display: "flex",
                    transition: "transform 0.6s ease",
                    transform: `translateX(-${pageTestimonial * 100}%)`,
                  }}
                >
                  {customerTestimonials?.map((item) => (
                    <Card
                      key={item._id}
                      style={{
                        flex: "0 0 100%",
                        padding: "48px 32px",
                        maxWidth: 800,
                        width: "100%",
                        textAlign: "center",
                        borderRadius: 16,
                        backgroundColor: "white",
                        boxShadow:
                          "0px 4px 20px rgba(0,0,0,0.06), 0px 8px 40px rgba(0,0,0,0.04)",
                      }}
                    >
                      <Avatar
                        src={item.imageUrl}
                        style={{
                          width: 80,
                          height: 80,
                          margin: "0 auto 16px auto",
                          borderRadius: 12,
                        }}
                      />
                      <Typography
                        variant="h6"
                        style={{
                          marginTop: 8,
                          fontWeight: 700,
                          fontSize: "1.2rem",
                          color: "#1a1a1a",
                        }}
                      >
                        {item.name}
                      </Typography>
                      {/* <Typography
                        variant="subtitle2"
                        style={{
                          fontSize: "0.95rem",
                          color: "#777",
                          marginBottom: 16,
                        }}
                      >
                        {item.location}
                      </Typography> */}
                      <Typography
                        variant="body1"
                        style={{
                          color: "#444",
                          lineHeight: 1.6,
                          maxWidth: 700,
                          margin: "0 auto",
                          fontWeight: "500",
                          fontSize: "17px",
                        }}
                      >
                        {item.feedback}
                      </Typography>
                    </Card>
                  ))}
                </Box>
              </Box>

              {/* Right Arrow */}
              {!isMobile && (
                <IconButton
                  onClick={goNextTestimonial}
                  disabled={pageTestimonial === totalPagesTestimonial - 1}
                  style={{
                    position: "absolute",
                    top: isMobile ? "100%" : "50%",
                    right: 40,
                    transform: "translateY(-50%)",
                    border: "1px solid #aaa",
                    background: "transparent",
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
                  }}
                >
                  <ArrowForwardIos />
                </IconButton>
              )}
            </Box>

            {/* Dots */}
            {!isMobile && (
              <Box
                style={{
                  marginTop: isMobile ? 10 : 24,
                  display: "flex",
                  justifyContent: "center",
                  gap: 8,
                }}
              >
                {customerTestimonials?.map((_, index) => (
                  <span
                    key={index}
                    onClick={() => setPageTestimonial(index)}
                    style={{
                      height: 10,
                      width: 10,
                      borderRadius: "50%",
                      backgroundColor:
                        pageTestimonial === index ? "#f47e46" : "#ccc",
                      cursor: "pointer",
                    }}
                  />
                ))}
              </Box>
            )}

            {/* Controls (arrows + dots together) for mobile */}
            {isMobile && (
              <Box
                style={{
                  marginTop: 14,
                  display: "flex",
                  alignItems: "center",
                  gap: 16,
                  justifyContent: "space-around",
                  width: "100%",
                }}
              >
                {/* Left Arrow */}
                <IconButton
                  style={{
                    transform: "translateY(-50%)",
                    background: "white",
                    border: "1px solid #ccc",
                    borderRadius: "50%",
                    width: 40,
                    marginTop: "50px",
                    height: 40,
                  }}
                  onClick={goPrevTestimonial}
                  disabled={pageTestimonial === 0}
                >
                  <ArrowBackIos />
                </IconButton>

                {/* Dots */}
                <Box
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: 8,
                  }}
                >
                  {customerTestimonials?.map((_, index) => (
                    <span
                      key={index}
                      onClick={() => setPageTestimonial(index)}
                      style={{
                        height: 10,
                        width: 10,
                        borderRadius: "50%",
                        cursor: "pointer",
                        backgroundColor:
                          pageTestimonial === index ? "#f47e46" : "#ccc",
                      }}
                    />
                  ))}
                </Box>

                {/* Right Arrow */}
                <IconButton
                  style={{
                    transform: "translateY(-50%)",
                    background: "white",
                    border: "1px solid #ccc",
                    borderRadius: "50%",
                    width: 40,
                    height: 40,
                    marginTop: "50px",
                  }}
                  onClick={goNextTestimonial}
                  disabled={pageTestimonial === customerTestimonials.length - 1}
                >
                  <ArrowForwardIos />
                </IconButton>
              </Box>
            )}
          </Box>

          {/* ----- Payment Schedule ------ */}

          <Box
            style={{
              padding: "1% 7%",
              backgroundColor: "#f5f5f5",
              marginTop: "3%",
            }}
            id="payment-terms"
          >
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                paddingTop: "10px",
                // border:"2px solid red"
              }}
            >
              <div
                style={{
                  width: "100px",
                  height: "3px",
                  background: "#d3d3d3",
                  margin: isMobile ? "0 auto 16px" : "0 0 16px",
                }}
              />

              <h2
                style={{
                  margin: "0 0 12px",
                  fontSize: isMobile ? "24px" : "32px",
                  fontWeight: 600,
                  color: "#130B38",
                  textAlign: isMobile ? "center" : "left",
                }}
              >
                Payment <span style={{ color: "#FF7A45" }}>Schedule</span>
              </h2>
            </Box>
            <Box
              style={{
                width: "100%",
                padding: isMobile ? "16px" : "40px",
              }}
            >
              {/* First row (3 boxes) */}
              <Box
                style={{
                  display: "grid",
                  gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)",
                  gap: "16px",
                }}
              >
                {dataPaymentSchedule.slice(0, 3).map((item) => (
                  <Box
                    key={item.id}
                    style={{
                      border: "1px dashed #ccc",
                      borderRadius: "8px",
                      padding: "24px",
                      textAlign: "center",
                      background: "#fff",
                    }}
                  >
                    {item.title && (
                      <Typography
                        style={{
                          fontSize: "24px",
                          fontWeight: "bold",
                          color: "#1c1c3d",
                        }}
                      >
                        {item.title}
                      </Typography>
                    )}
                    <Typography
                      style={{ color: "#555", marginTop: 8, fontWeight: "600" }}
                    >
                      {item.desc}
                    </Typography>
                  </Box>
                ))}
              </Box>

              {/* Second row (2 boxes) */}
              <Box
                style={{
                  display: "grid",
                  gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
                  gap: "16px",
                  marginTop: "16px",
                }}
              >
                {dataPaymentSchedule.slice(3, 5).map((item) => (
                  <Box
                    key={item.id}
                    style={{
                      border: "1px dashed #ccc",
                      borderRadius: "8px",
                      padding: "24px",
                      textAlign: "center",
                      background: "#fff",
                    }}
                  >
                    <Typography style={{ color: "#555", fontWeight: "600" }}>
                      {item.desc}
                    </Typography>
                  </Box>
                ))}
              </Box>

              {/* Highlighted Blocks with Orange Stripe */}
              <Box
                style={{
                  marginTop: "16px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                }}
              >
                {dataPaymentSchedule.slice(5).map((item) => (
                  <Box
                    key={item.id}
                    style={{
                      border: "1px dashed #ccc",
                      borderRadius: "8px",
                      background: "#fff",
                      display: "flex",
                      overflow: "hidden",
                    }}
                  >
                    {/* Orange stripe (fixed height = full box height) */}
                    <Box
                      style={{
                        width: "15px",
                        background: "#f47e46",
                        flexShrink: 0,
                      }}
                    />

                    {/* Content */}
                    <Box style={{ padding: "24px", flex: 1 }}>
                      <Typography
                        style={{
                          fontSize: "20px",
                          fontWeight: "bold",
                          color: "#1c1c3d",
                        }}
                      >
                        {item.title}
                      </Typography>
                      <Typography
                        style={{
                          color: "#555",
                          marginTop: 6,
                          fontWeight: "600",
                        }}
                      >
                        {item.desc}
                      </Typography>
                    </Box>
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>

          {/* ----------ANNEXURE-1- MATERIAL SPECIFICATION--------- */}

          <Box
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              marginTop: 40,
              overflow: "hidden",
              padding: "0 7%",
            }}
          >
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                paddingTop: "10px",
              }}
            >
              <div
                style={{
                  width: "100px",
                  height: "3px",
                  background: "#d3d3d3",
                  margin: isMobile ? "0 auto 16px" : "0 0 16px",
                }}
              />

              <h2
                style={{
                  margin: "0 0 12px",
                  fontSize: isMobile ? "24px" : "32px",
                  fontWeight: 600,
                  color: "#130B38",
                  textAlign: isMobile ? "center" : "left",
                }}
              >
                ANNEXURE-1{" "}
                <span style={{ color: "#FF7A45" }}>MATERIAL SPECIFICATION</span>
              </h2>
            </Box>

            <Box
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                position: "relative",
                height: "450px",
              }}
            >
              {/* Left Arrow */}
              {!isMobile && (
                <IconButton
                  onClick={goPrevAnnexure}
                  disabled={pageAnnexure === 0}
                  style={{
                    position: "absolute",
                    top: isMobile ? "100%" : "50%",
                    left: 40,
                    transform: "translateY(-50%)",
                    border: "1px solid #aaa",
                    background: "transparent",
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
                  }}
                >
                  <ArrowBackIos />
                </IconButton>
              )}
              {/* Slider */}
              <Box style={{ width: "100%", maxWidth: 800, overflow: "hidden" }}>
                <Box
                  style={{
                    display: "flex",
                    transition: "transform 0.6s ease",
                    transform: `translateX(-${pageAnnexure * 100}%)`,
                  }}
                >
                  {/* First Slide with Table 1 */}
                  <Box style={{ flex: "0 0 100%" }}>
                    <TableContainer
                      style={{
                        borderRadius: 2,
                        border: "1px dashed #ccc",
                      }}
                    >
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell
                              style={{
                                backgroundColor: "#FF7A45",
                                color: "white",
                                fontWeight: 600,
                                fontSize: "16px",
                              }}
                            >
                              Particulars
                            </TableCell>
                            <TableCell
                              style={{
                                backgroundColor: "#FF7A45",
                                color: "white",
                                fontWeight: 600,
                                fontSize: "16px",
                              }}
                            >
                              Brand
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {dataTable.map((row, index) => (
                            <TableRow key={index}>
                              <TableCell
                                style={{
                                  fontSize: "15px",
                                  color: "#444",
                                  padding: "12px 16px",
                                }}
                              >
                                {row.particular}
                              </TableCell>
                              <TableCell
                                style={{
                                  fontSize: "15px",
                                  color: "#444",
                                  padding: "12px 16px",
                                }}
                              >
                                {row.brand}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>

                  {/* Second Slide with Table 2 */}
                  <Box style={{ flex: "0 0 100%", marginTop: "24px" }}>
                  <TableContainer
                    style={{
                      borderRadius: 2,
                      border: "1px dashed #ccc",
                    }}
                  >
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell
                            colSpan={2} // full width heading
                            style={{
                              backgroundColor: "#FF7A45",
                              color: "white",
                              fontWeight: 600,
                              fontSize: "16px",
                              textAlign: "center",
                            }}
                          >
                            FINAL FINISH PANEL THICKNESS INCLUDING LAMINATES
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell
                            style={{
                              fontSize: "15px",
                              color: "#444",
                              padding: "12px 16px",
                            }}
                          >
                            Back & Drawer Bottom Panel
                          </TableCell>
                          <TableCell
                            style={{
                              fontSize: "15px",
                              color: "#444",
                              padding: "12px 16px",
                            }}
                          >
                            6 mm*
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            style={{
                              fontSize: "15px",
                              color: "#444",
                              padding: "12px 16px",
                            }}
                          >
                            Other Panels
                          </TableCell>
                          <TableCell
                            style={{
                              fontSize: "15px",
                              color: "#444",
                              padding: "12px 16px",
                            }}
                          >
                            18 mm*
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            colSpan={2}
                            style={{
                              fontSize: "14px",
                              color: "#444",
                              padding: "12px 16px",
                              fontStyle: "italic",
                              textAlign:"center"
                            }}
                          >
                            * Unless otherwise specifically mentioned
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                </Box>
              </Box>

              {/* Right Arrow */}
              {!isMobile && (
                <IconButton
                  onClick={goNextAnnexure}
                  disabled={pageAnnexure === totalPagesAnnexure - 1}
                  style={{
                    position: "absolute",
                    top: isMobile ? "100%" : "50%",
                    right: 40,
                    transform: "translateY(-50%)",
                    border: "1px solid #aaa",
                    background: "transparent",
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
                  }}
                >
                  <ArrowForwardIos />
                </IconButton>
              )}
            </Box>

            {/* Dots */}
            {!isMobile && (
              <Box
                style={{
                  marginTop: isMobile ? 10 : 24,
                  display: "flex",
                  justifyContent: "center",
                  gap: 8,
                }}
              >
                {[1, 2].map((_, index) => (
                  <span
                    key={index}
                    onClick={() => setPageAnnexure(index)}
                    style={{
                      height: 10,
                      width: 10,
                      borderRadius: "50%",
                      backgroundColor:
                        pageAnnexure === index ? "#f47e46" : "#ccc",
                      cursor: "pointer",
                    }}
                  />
                ))}
              </Box>
            )}

            {/* Controls (arrows + dots together) for mobile */}
            {isMobile && (
              <Box
                style={{
                  marginTop: 14,
                  display: "flex",
                  alignItems: "center",
                  gap: 16,
                  justifyContent: "space-around",
                  width: "100%",
                }}
              >
                {/* Left Arrow */}
                <IconButton
                  style={{
                    transform: "translateY(-50%)",
                    background: "white",
                    border: "1px solid #ccc",
                    borderRadius: "50%",
                    width: 40,
                    marginTop: "50px",
                    height: 40,
                  }}
                  onClick={goPrevAnnexure}
                  disabled={pageAnnexure === 0}
                >
                  <ArrowBackIos />
                </IconButton>

                {/* Dots */}
                <Box
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: 8,
                  }}
                >
                  {[1, 2].map((_, index) => (
                    <span
                      key={index}
                      onClick={() => setPageAnnexure(index)}
                      style={{
                        height: 10,
                        width: 10,
                        borderRadius: "50%",
                        cursor: "pointer",
                        backgroundColor:
                          pageAnnexure === index ? "#f47e46" : "#ccc",
                      }}
                    />
                  ))}
                </Box>

                {/* Right Arrow */}
                <IconButton
                  style={{
                    transform: "translateY(-50%)",
                    background: "white",
                    border: "1px solid #ccc",
                    borderRadius: "50%",
                    width: 40,
                    height: 40,
                    marginTop: "50px",
                  }}
                  onClick={goNextAnnexure}
                  disabled={pageAnnexure === 2 - 1}
                >
                  <ArrowForwardIos />
                </IconButton>
              </Box>
            )}
          </Box>

          {/* ----------Payment Details Section--------- */}

          <Box style={{ padding: "1% 7%" }}>
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                paddingTop: "10px",
                // border:"2px solid red"
              }}
            >
              <div
                style={{
                  width: "100px",
                  height: "3px",
                  background: "#d3d3d3",
                  margin: isMobile ? "0 auto 16px" : "0 0 16px",
                }}
              />

              <h2
                style={{
                  margin: "0 0 12px",
                  fontSize: isMobile ? "24px" : "32px",
                  fontWeight: 600,
                  color: "#130B38",
                  textAlign: isMobile ? "center" : "left",
                }}
              >
                Payment <span style={{ color: "#FF7A45" }}>Details</span>
              </h2>
            </Box>
            <Box sx={{ px: 2, py: 4 }}>
              {/* Card Section */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row",
                  alignItems: isMobile ? "flex-start" : "center",
                  gap: isMobile ? 1.5 : 4,
                  border: "1px dashed #D1D5DB",
                  borderRadius: "12px",
                  boxShadow: "0px 4px 8px rgba(0,0,0,0.05)",
                  background: "#fff",
                  p: 3,
                  position: "relative",
                }}
              >
                {/* Orange Bar */}
                <Box
                  sx={{
                    position: "absolute",
                    left: 0,
                    top: 0,
                    bottom: 0,
                    width: "8px",
                    bgcolor: "#F47E46",
                    borderTopLeftRadius: "12px",
                    borderBottomLeftRadius: "12px",
                  }}
                />

                {/* Content */}
                <Box sx={{ ml: 2 }}>
                  <Typography
                    variant="h5"
                    sx={{ fontWeight: 600, color: "#1C1C1C", mb: 1 }}
                  >
                    We accept
                  </Typography>

                  <Box
                    style={{
                      display: "flex",
                      flexDirection: isMobile ? "column" : "row",
                      gap: isMobile ? 0.5 : 2,
                      color: "#6B7280",
                      fontSize: "16px",
                      fontWeight: 600,
                    }}
                  >
                    <Typography style={{ fontWeight: 600 }}>
                      Bank transfers, UPI{" "}
                    </Typography>
                    {!isMobile && (
                      <Typography style={{ fontWeight: "600" }}>& </Typography>
                    )}
                    <Typography style={{ fontWeight: 600 }}>
                      Cheque payments for 90% payment post the 10% Initial
                      amount
                    </Typography>
                  </Box>
                </Box>
              </Box>

              {/* Below Note */}
              <Typography
                style={{
                  padding: "20px 0px",
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "#1C1C3C",
                }}
              >
                You can also make an Online transaction to the below account
                details
              </Typography>

              <div
                style={{
                  width: "300px",
                  height: "3px",
                  background: "#d3d3d3",
                  margin: isMobile ? "0 auto 16px" : "0 0 16px",
                }}
              />
            </Box>

            {/* ------Bank Details----------    */}

            {/* ----For Desktop Version----- */}
            {!isMobile && (
              <Box
                style={{
                  // maxWidth: 1120,
                  // margin: "24px auto",
                  borderRadius: 14,
                  overflow: "hidden",
                  background: "#fff",
                  boxShadow: "0 2px 8px rgba(0,0,0,.08)",
                  width: "100%",
                }}
              >
                {/* Top banner */}
                <Box
                  style={{
                    width: "100%",
                    borderBottom: "2px dashed #e7e7ea",
                  }}
                >
                  <img
                    style={{
                      width: "100%",
                      height: "auto", // keeps proportions
                      display: "block",
                    }}
                    src={PaymentBanner}
                    alt="Payment banner"
                  />
                </Box>

                <Box style={{
                  width: "100%",
                  padding: "20px",
                  marginBottom: "16px",
                  border: "2px solid #e0e0e0",
                  borderRadius: "8px",
                  // backgroundColor: "#f9f9f9",
                  textAlign: "center",
                  // boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                }}>
                  <p style={{ margin: "0 0 12px 0", fontSize: "17px", lineHeight: "1.6", color: "#333" }}>
                  Below mentioned Banking details and QR code is only for Name : <span style={{fontWeight:"600"}}>{capitalizeFirstWord(quotationInfo?.customer?.name)} </span> | Project No. : {quotationInfo?.uniqueLeadNumber?.split("").map((char, index) => (
                        <span
                          key={index}
                          style={{
                            color: /\d/.test(char) ? "#E57C4E" : "#5A5A7C",
                            fontWeight:"600"
                          }}
                        >
                          {char}
                        </span>
                      ))}
                  </p>
                  <p style={{ margin: "0", fontSize: "16px", lineHeight: "1.6", color: "red",fontWeight:"600" }}>
                  Note: Please do not share the Bank Details & QR Code with anyone.
                  </p>
                </Box> 

                <Box
                  style={{
                    padding: "22px 24px 26px",
                    border: "2px dashed #e7e7ea",
                    borderTop: "none",
                    borderRadius: "0 0 12px 12px",
                  }}
                >
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "220px 220px 220px 3px 1frpx",
                      gridAutoRows: "minmax(28px, auto)",
                      rowGap: 22,
                      columnGap: 20,
                      alignItems: "center",
                    }}
                  >
                    {/* Row 1 - Name */}
                    <Typography
                      style={{
                        color: "#626277",
                        fontWeight: 500,
                        gridColumn: 1,
                        gridRow: 1,
                      }}
                    >
                      Name :
                    </Typography>
                    <Typography
                      style={{
                        color: "#2c2c36",
                        fontWeight: 500,
                        gridColumn: 2,
                        gridRow: 1,
                      }}
                    >
                      DECORPOT PRIVATE LIMITED
                    </Typography>

                    {/* Row 2 - Virtual A/C */}
                    <Typography
                      style={{
                        color: "#626277",
                        fontWeight: 500,
                        gridColumn: 1,
                        gridRow: 2,
                      }}
                    >
                      Virtual A/C No. :
                    </Typography>
                    <Typography
                      style={{
                        color: "#2c2c36",
                        fontWeight: 600,
                        gridColumn: 2,
                        gridRow: 2,
                      }}
                    >
                      {colouredLeadNumber.split("").map((char, index) => (
                        <span
                          key={index}
                          style={{
                            color: /\d/.test(char) ? "#E57C4E" : "#5A5A7C",
                          }}
                        >
                          {char}
                        </span>
                      ))}
                    </Typography>
                    <div style={{ gridColumn: 3, gridRow: 2 }}>
                      <Legend />
                    </div>

                    {/* Row 3 - Bank + IFSC */}
                    <Typography
                      style={{
                        color: "#626277",
                        fontWeight: 500,
                        gridColumn: 1,
                        gridRow: 3,
                      }}
                    >
                      Bank :
                    </Typography>
                    <Typography
                      style={{
                        color: "#2c2c36",
                        fontWeight: 500,
                        gridColumn: 2,
                        gridRow: 3,
                      }}
                    >
                      HDFC Bank
                    </Typography>

                    <Box
                      style={{
                        gridColumn: 3,
                        gridRow: 3,
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        gap: "16px",
                      }}
                    >
                      <Typography style={{ color: "#626277", fontWeight: 500 }}>
                        Bank IFSC :
                      </Typography>
                      <Typography style={{ color: "#2c2c36", fontWeight: 500 }}>
                        HDFC0001993
                      </Typography>
                    </Box>

                    {/* Row 4 - Branch + A/c Type */}
                    <Typography
                      style={{
                        color: "#626277",
                        fontWeight: 500,
                        gridColumn: 1,
                        gridRow: 4,
                      }}
                    >
                      Branch :
                    </Typography>
                    <Typography
                      style={{
                        color: "#2c2c36",
                        fontWeight: 500,
                        gridColumn: 2,
                        gridRow: 4,
                      }}
                    >
                      HSR Main Branch
                    </Typography>

                    <Box
                      style={{
                        gridColumn: 3,
                        gridRow: 4,
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        gap: "16px",
                      }}
                    >
                      <Typography style={{ color: "#626277", fontWeight: 500 }}>
                        A/C Type :
                      </Typography>
                      <Typography style={{ color: "#2c2c36", fontWeight: 500 }}>
                        Current Account
                      </Typography>
                    </Box>

                    {/* Row 5 - UPI */}
                    <Typography
                      style={{
                        color: "#626277",
                        fontWeight: 500,
                        gridColumn: 1,
                        gridRow: 5,
                      }}
                    >
                      UPI ID :
                    </Typography>
                    <Typography
                      style={{
                        color: "#2c2c36",
                        fontWeight: 600,
                        gridColumn: 2,
                        gridRow: 5,
                      }}
                    >
                      {colouredLeadNumber.split("").map((char, index) => (
                        <span
                          key={index}
                          style={{
                            color: /\d/.test(char) ? "#E57C4E" : "#5A5A7C",
                          }}
                        >
                          {char}
                        </span>
                      ))}
                      @hdfcbank
                    </Typography>
                    <div
                      style={{
                        background: "#E0E0E6",
                        width: 2,
                        height: "100%",
                        gridColumn: 4,
                        gridRow: "1 / span 5",
                        marginLeft: "100px",
                      }}
                    />

                    {/* QR Code */}
                    <div
                      style={{
                        textAlign: "center",
                        paddingLeft: 18,
                        gridColumn: 5,
                        gridRow: "1 / span 5",
                      }}
                    >
                    <div
                      style={{
                        color: "#26263F",
                        fontWeight: 700,
                        fontSize: 20,
                        lineHeight: 1.2,
                        marginBottom: 10,
                        width: "230px",
                        margin: "0 auto",
                        textAlign: "center",
                      }}
                    >
                      {/* Don't tell them to scan something that isn't there. */}
                      {quotationInfo?.payment_qr_code && !qrLoadFailed ? (
                        <>
                          Scan the QR code to
                          <br />
                          pay through{" "}
                          <span style={{ color: "#F18A52", fontWeight: 800 }}>
                            UPI
                          </span>
                        </>
                      ) : (
                        <>
                          Paying by{" "}
                          <span style={{ color: "#F18A52", fontWeight: 800 }}>
                            UPI
                          </span>
                          ?
                        </>
                      )}
                    </div>

                      {/* <Typography style={{fontSize: "15px", marginTop:"15px"}}>
                      Available/Valid for below mentioned customer name and project Number
                      </Typography> */}

                    {quotationInfo?.payment_qr_code && !qrLoadFailed ? (
                      <QrCard
                        src={quotationInfo?.payment_qr_code}
                        size={200}
                        virtualAccount={colouredLeadNumber}
                        onCopy={handleCopy}
                        onError={() => setQrLoadFailed(true)}
                      />
                    ) : (
                      <PaymentQrUnavailable
                        size={200}
                        virtualAccount={colouredLeadNumber}
                        onCopy={handleCopy}
                      />
                    )}

                    </div>
                  </div>
                </Box>
              </Box>
            )}            

            {/* ----For Mobile Version----- */}

            {isMobile && (
              <Paper
                elevation={3}
                style={{
                  // width: 340,
                  border: "1px dashed #999",
                  borderRadius: 8,
                  overflow: "hidden",
                }}
              >
                {/* Orange Header */}
                <Box
                  style={{
                    backgroundColor: "#f47e46",
                    // height: 40,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#fff",
                    fontWeight: "bold",
                  }}
                >
                  <Box
                    style={{
                      width: "100%",
                      borderBottom: "2px dashed #e7e7ea",
                    }}
                  >
                    <img
                      style={{
                        width: "100%",
                        height: "auto", // keeps proportions
                        display: "block",
                      }}
                      src={PaymentBanner}
                      alt="Payment banner"
                    />
                  </Box>
                </Box>
                <Box style={{
                  width: "100%",
                  padding: "20px",
                  marginBottom: "16px",
                  border: "2px solid #e0e0e0",
                  borderRadius: "8px",
                  // backgroundColor: "#f9f9f9",
                  textAlign: "center",
                  // boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                }}>
                  <p style={{ margin: "0 0 12px 0", fontSize: "17px", lineHeight: "1.6", color: "#333" }}>
                  Below mentioned Banking details and QR code is only for Name : <span style={{fontWeight:"600"}}>{capitalizeFirstWord(quotationInfo?.customer?.name)} </span> | Project No. : {quotationInfo?.uniqueLeadNumber?.split("").map((char, index) => (
                        <span
                          key={index}
                          style={{
                            color: /\d/.test(char) ? "#E57C4E" : "#5A5A7C",
                            fontWeight:"600"
                          }}
                        >
                          {char}
                        </span>
                      ))}
                  </p>
                  <p style={{ margin: "0", fontSize: "16px", lineHeight: "1.6", color: "red",fontWeight:"600" }}>
                   Note: Please do not share the Bank Details & QR Code with anyone.
                  </p>
                </Box> 

                {/* Details Section */}
                <Box style={{ padding: "10px" }}>
                  {bankDetails.map((item, index) => (
                    <Box key={index} style={{ marginBottom: 16 }}>
                      <Typography
                        variant="body2"
                        style={{ fontWeight: "bold", marginBottom: 4 }}
                      >
                        {item.label} :
                      </Typography>
                      <Box display="flex" alignItems="center">
                        <Typography
                          variant="body2"
                          style={{ flex: 1, color: "#1C375D" }}
                        > {item.label==="Virtual A/C Number"?colouredLeadNumber:item.value}
                        </Typography>
                        <IconButton
                          size="small"
                          onClick={() => handleCopy(item.value)}
                          style={{ color: "#f47e46" }}
                        >
                          <FileCopyIcon fontSize="small" />
                        </IconButton>
                      </Box>
                      {index !== bankDetails.length - 1 && (
                        <Divider style={{ marginTop: 8 }} />
                      )}
                    </Box>
                  ))}

                  <Typography variant="h6" style={{ textAlign: "center" }}>
                    {/* Don't tell them to scan something that isn't there. */}
                    {quotationInfo?.payment_qr_code && !qrLoadFailed ? (
                      <>
                        Scan the QR code to pay through{" "}
                        <b style={{ color: "#e87541" }}>UPI</b>
                      </>
                    ) : (
                      <>
                        Paying by <b style={{ color: "#e87541" }}>UPI</b>?
                      </>
                    )}
                  </Typography>
                  <Box
                    display="flex"
                    justifyContent="center"
                    style={{ marginTop: "10px" }}
                  >
                    {quotationInfo?.payment_qr_code && !qrLoadFailed ? (
                      <QrCard
                        src={quotationInfo?.payment_qr_code}
                        size={180}
                        virtualAccount={colouredLeadNumber}
                        onCopy={handleCopy}
                        onError={() => setQrLoadFailed(true)}
                      />
                    ) : (
                      <PaymentQrUnavailable
                        size={180}
                        virtualAccount={colouredLeadNumber}
                        onCopy={handleCopy}
                      />
                    )}
                  </Box>

                </Box>
              </Paper>
            )}

            <Typography
              variant="h6"
              style={{
                fontWeight: "600",
                marginTop: isMobile ? "50px" : "70px",
              }}
            >
              Please issue A/C Payee cheques in the name of{" "}
              <span style={{ color: "#F47E46" }}>
                "DECORPOT PRIVATE LIMITED"
              </span>
            </Typography>
          </Box>

          {/* ---------- Footer --------- */}
          <Box
            style={{
              padding: "1% 7%",
              backgroundColor: "#f5f5f5",
              marginTop: "30px",
            }}
            id="contact-us"
          >
            <Box
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: isMobile ? "column" : "row",
              }}
            >
              <Box style={{ flex: "1 1 250px", maxWidth: 450 }}>
                <Box display="flex" alignItems="center">
                  <img
                    src={BlueLogo}
                    alt="decorpot"
                    className={classes?.logo}
                    style={{ width: "50%", height: "50%" }}
                  />
                </Box>
                <p style={{ margin: "0", fontSize: "18px", color: "#555" }}>
                  Decorpot is a leading and people's favorite home interior
                  brand which was founded in 2015 with an aim of creating
                  premium and luxury end-to-end home interiors at fair prices
                  and delivering the dreams of the clients.
                </p>
              </Box>
              <div style={{ marginTop: "15px" }}>
                <h4
                  style={{
                    marginBottom: 15,
                    color: "#1C1C1C",
                    fontSize: "18px",
                  }}
                >
                  Contact Us
                </h4>
                <p style={{ margin: "0", fontSize: "18px", color: "#555" }}>
                  📍{" "}
                  <a
                    style={{
                      textDecoration: "none",
                      margin: "0",
                      fontSize: "18px",
                      color: "#555",
                    }}
                    href={"https://www.decorpot.com/contact-us"}
                    target="_blank"
                  >
                    Our Locations
                    {/* {entry?.name} */}
                  </a>
                </p>
                <p style={{ margin: "0", fontSize: "18px", color: "#555" }}>
                  📞{" "}
                  <a
                    href="tel:9108602000"
                    style={{ color: "#555", textDecoration: "none" }}
                  >
                    9108602000
                  </a>
                </p>
                <p style={{ margin: "0", fontSize: "18px", color: "#555" }}>
                  ✉️{" "}
                  <a
                    href="mailto:hello@decorpot.com"
                    style={{ color: "#555", textDecoration: "none" }}
                  >
                    hello@decorpot.com
                  </a>
                </p>
              </div>

              <div style={{ marginTop: "15px" }}>
                <h4
                  style={{
                    marginBottom: 15,
                    color: "#1C1C1C",
                    fontSize: "18px",
                  }}
                >
                  Helps
                </h4>
                <p style={{ margin: "0", fontSize: "18px", color: "#555" }}>
                  <a
                    style={{
                      textDecoration: "none",
                      margin: "0",
                      fontSize: "18px",
                      color: "#555",
                    }}
                    href={
                      "https://decorpotprivatelimited.zohodesk.in/portal/en/newticket"
                    }
                    target="_blank"
                  >
                    Raise Issue
                    {/* {entry?.name} */}
                  </a>
                </p>
                <p style={{ margin: "0", fontSize: "18px", color: "#555" }}>
                  <a
                    style={{
                      textDecoration: "none",
                      margin: "0",
                      fontSize: "18px",
                      color: "#555",
                    }}
                    href={"https://www.decorpot.com/store-locator"}
                    target="_blank"
                  >
                    Store Locator
                    {/* {entry?.name} */}
                  </a>
                  {/* Store Locator */}
                </p>
                <p style={{ margin: "0", fontSize: "18px", color: "#555" }}>
                </p>
              </div>

              {/* Useful Links */}
              <div style={{ marginTop: "15px" }}>
                <h4
                  style={{
                    marginBottom: 15,
                    color: "#1C1C1C",
                    fontSize: "18px",
                  }}
                >
                  Useful Links
                </h4>
                <p
                  style={{
                    margin: "0",
                    fontSize: "18px",
                    color: "#555",
                    cursor: "pointer",
                  }}
                >
                  <a
                    href="#projectQuote"
                    style={{ textDecoration: "none", color: "#555" }}
                  >
                    Project Quote
                  </a>
                </p>

                <p
                  style={{
                    margin: "0",
                    fontSize: "18px",
                    color: "#555",
                    cursor: "pointer",
                  }}
                >
                  <a
                    href="#cost-breakdown"
                    style={{ textDecoration: "none", color: "#555" }}
                  >
                    Cost Breakdown
                  </a>
                </p>

                <p
                  style={{
                    margin: "0",
                    fontSize: "18px",
                    color: "#555",
                    cursor: "pointer",
                  }}
                >
                  <a
                    href="#testimonial"
                    style={{ textDecoration: "none", color: "#555" }}
                  >
                    Customer Testimonials
                  </a>
                </p>
              </div>
            </Box>

            {/* Divider */}
            <div
              style={{
                borderTop: "1px solid #ddd",
                margin: "30px 0",
              }}
            />
            {/* Bottom Section */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "15px",
              }}
            >
              {/* Copyright */}
              <p
                style={{
                  color: "#555",
                  fontSize: "18px",
                  margin: 0,
                }}
              >
                © 2025 Decorpot Home Interiors. All Rights Reserved
              </p>

              {/* Social Icons */}
              <Box
                style={{
                  padding: "5px",
                  width: isMobile ? "90%" : "17%",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                {socialMediaLinks?.map((entry) => {
                  return (
                    <a
                      href={entry?.socialUrl}
                      target="_blank"
                      style={{
                        ...iconStyle,
                        // border:"2px solid red"
                      }}
                    >
                      <i
                        className={`${entry.iconCode} fa-2x`}
                        // style={{ marginRight: 8 }}
                      ></i>
                      {/* {entry?.name} */}
                    </a>
                  );
                })}
              </Box>
              {/* </div> */}
            </div>
          </Box>
        </Box>
      )}
    </Box>
  );
}

export default connect(null, { setLoading, setSnackInfo })(CxWebQuotation);


